"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.f97 = void 0;
exports.f97 = {
    "afar": [
        3,
        4,
        5,
        6,
        7
    ],
    "alumu-tesu": [
        9
    ],
    "alumu": [
        9
    ],
    "arum-cesu": [
        9
    ],
    "arum-chessu": [
        9
    ],
    "arum-tesu": [
        9
    ],
    "ari": [
        10,
        5660,
        2252
    ],
    "amal": [
        11
    ],
    "alai": [
        11
    ],
    "albanian, arbëreshë": [
        12,
        13
    ],
    "albanian": [
        12,
        13,
        25,
        269,
        270,
        7068,
        7069,
        7070,
        7071,
        7072,
        7073,
        7074,
        7077
    ],
    "arbëreshë": [
        12,
        13
    ],
    "arbëreshë albanian": [
        12,
        13
    ],
    "arbërisht": [
        12,
        13,
        25
    ],
    "arbërishtja": [
        12,
        13
    ],
    "aranadan": [
        14
    ],
    "aranatan": [
        14
    ],
    "arnatas": [
        14
    ],
    "ambrak": [
        15
    ],
    "abu’": [
        16
    ],
    "abu' arapesh": [
        16
    ],
    "abu": [
        99,
        16
    ],
    "arapesh": [
        16,
        353,
        354,
        355,
        359,
        371,
        372,
        373
    ],
    "abu’ arapesh": [
        16
    ],
    "arifama-miniafia": [
        17
    ],
    "ankave": [
        18
    ],
    "aga pɨ'ne'": [
        18
    ],
    "aga": [
        18,
        861,
        3925,
        3926,
        8840
    ],
    "aga pɨ’ne’": [
        18
    ],
    "angave": [
        18
    ],
    "ankave-anga": [
        18
    ],
    "afade": [
        19
    ],
    "afada": [
        19
    ],
    "afadee": [
        19
    ],
    "afadeh": [
        19
    ],
    "afaɗә": [
        19
    ],
    "affade": [
        19
    ],
    "anambé": [
        20
    ],
    "arabic, algerian saharan spoken": [
        21
    ],
    "arabic": [
        21,
        39,
        55,
        70,
        73,
        81,
        82,
        83,
        84,
        85,
        91,
        116,
        117,
        118,
        136,
        224,
        225,
        226,
        227,
        368,
        369,
        370,
        405,
        406,
        407,
        408,
        409,
        410,
        411,
        412,
        413,
        414,
        415,
        416,
        417,
        418,
        419,
        420,
        421,
        422,
        423,
        424,
        425,
        426,
        427,
        428,
        429,
        430,
        431,
        432,
        433,
        434,
        449,
        451,
        456,
        457,
        458,
        531,
        537,
        579,
        582,
        583,
        585,
        3450,
        6855,
        6856,
        7136,
        8791,
        8922,
        659,
        6111,
        7082,
        8389,
        3421,
        4704,
        4705
    ],
    "algerian": [
        474,
        21,
        449
    ],
    "algerian saharan arabic": [
        21
    ],
    "algeria": [
        21,
        411,
        449,
        474,
        1556,
        2433,
        2775,
        3458,
        3459,
        3460,
        3530,
        5256,
        5257,
        5258,
        5998,
        6860,
        6861,
        6862,
        7486,
        7487,
        7488,
        7489,
        7496,
        7527
    ],
    "arára, pará": [
        22
    ],
    "arára": [
        22,
        567,
        450
    ],
    "arára bravos": [
        22
    ],
    "abenaki, eastern": [
        23
    ],
    "abenaki": [
        23,
        36
    ],
    "alnombak": [
        23,
        36
    ],
    "alnôbak": [
        23,
        36
    ],
    "abnaki": [
        23,
        36
    ],
    "aasáx": [
        24
    ],
    "aasá": [
        24
    ],
    "aramanik": [
        24
    ],
    "asak": [
        24,
        9061
    ],
    "asax": [
        24
    ],
    "assa": [
        24
    ],
    "asá": [
        24
    ],
    "albanian, arvanitika": [
        25
    ],
    "arvanitika": [
        25,
        7068,
        7070,
        7071
    ],
    "arberichte": [
        25
    ],
    "arvanitic": [
        25
    ],
    "arvanitika albanian": [
        25
    ],
    "abau": [
        26
    ],
    "arawe": [
        27
    ],
    "arove": [
        27
    ],
    "atas": [
        28,
        5272
    ],
    "amarasi": [
        29
    ],
    "abkhaz": [
        30,
        31
    ],
    "abkhazian": [
        30,
        31
    ],
    "abxazo": [
        30,
        31
    ],
    "abé": [
        32
    ],
    "abbey": [
        32
    ],
    "abbé": [
        32
    ],
    "abi": [
        32
    ],
    "abaw": [
        33
    ],
    "abo": [
        33,
        4886,
        8792
    ],
    "ayta, ambala": [
        34
    ],
    "ayta": [
        34,
        46,
        587,
        588,
        938,
        6807,
        590,
        6702
    ],
    "ambala": [
        34,
        122
    ],
    "ambala agta": [
        34
    ],
    "agta": [
        161,
        169,
        175,
        374,
        495,
        1815,
        1998,
        2008,
        2017,
        2034,
        35,
        2005,
        34,
        171
    ],
    "ambala ayta": [
        34
    ],
    "ambala sambal": [
        34
    ],
    "ayta ambala": [
        34
    ],
    "abiyan": [
        35
    ],
    "abenaki, western": [
        36
    ],
    "abenaqui": [
        36
    ],
    "abai sungai": [
        37
    ],
    "abai": [
        37
    ],
    "abaga": [
        38
    ],
    "arabic, tajiki spoken": [
        39
    ],
    "arabi": [
        370,
        6856,
        39,
        70,
        369,
        6111
    ],
    "asian": [
        1378,
        39,
        531
    ],
    "abidji": [
        40
    ],
    "abiji": [
        40
    ],
    "aka-bea": [
        41
    ],
    "aka-beada": [
        41
    ],
    "aka-biada": [
        41
    ],
    "abung": [
        42
    ],
    "abanyom": [
        43
    ],
    "abanyum": [
        43
    ],
    "abua": [
        44
    ],
    "abuan": [
        44
    ],
    "abon": [
        45
    ],
    "abong": [
        45
    ],
    "abõ": [
        45
    ],
    "ayta, abellen": [
        46
    ],
    "abellen": [
        46
    ],
    "abellen ayta": [
        46
    ],
    "abenlen": [
        46
    ],
    "aburlen negrito": [
        46
    ],
    "aburlen": [
        46
    ],
    "aburlin": [
        46
    ],
    "ayta abellen": [
        46
    ],
    "ayta abellen sambal": [
        46
    ],
    "abaza": [
        47,
        48
    ],
    "abazin": [
        47,
        48
    ],
    "abazintsy": [
        47,
        48
    ],
    "ahuwa": [
        47,
        48
    ],
    "ashuwa": [
        47,
        48
    ],
    "abron": [
        49
    ],
    "ambonese": [
        50
    ],
    "ambon malay": [
        50
    ],
    "ambon": [
        50,
        4314,
        7581
    ],
    "ambonese malay": [
        50
    ],
    "ambong": [
        50
    ],
    "ambulas": [
        51,
        52,
        53
    ],
    "abulas": [
        51,
        52,
        53
    ],
    "abelam": [
        51,
        52,
        53
    ],
    "ambulas - maprik": [
        52
    ],
    "ambulas - wosera kamu": [
        53
    ],
    "abure": [
        54
    ],
    "abonwa": [
        54
    ],
    "abouré": [
        54
    ],
    "abule": [
        54
    ],
    "akaplass": [
        54
    ],
    "arabic, baharna spoken": [
        55
    ],
    "abasakur": [
        56
    ],
    "abaknon": [
        57
    ],
    "abaknon sama": [
        57
    ],
    "aneme wake": [
        58
    ],
    "aneme": [
        58
    ],
    "abia": [
        58
    ],
    "abie": [
        58
    ],
    "abui": [
        59
    ],
    "achagua": [
        60
    ],
    "ajagua": [
        60
    ],
    "achode": [
        62
    ],
    "akyode": [
        62
    ],
    "aceh": [
        63,
        64
    ],
    "acehnese": [
        63,
        64
    ],
    "achehnese": [
        63,
        64
    ],
    "achinese": [
        63,
        64
    ],
    "atjehnese": [
        63,
        64
    ],
    "acèh": [
        63,
        64
    ],
    "antillean": [
        65
    ],
    "acholi": [
        66
    ],
    "acoli": [
        66
    ],
    "acooli": [
        66
    ],
    "akoli": [
        66
    ],
    "atscholi": [
        66
    ],
    "aka-cari": [
        67
    ],
    "akacari": [
        67
    ],
    "aka-kora": [
        68
    ],
    "akar-bale": [
        69
    ],
    "arabic, mesopotamian spoken": [
        70
    ],
    "achang": [
        71
    ],
    "acang": [
        71
    ],
    "achung": [
        71
    ],
    "ach’ang": [
        71
    ],
    "ahchan": [
        71
    ],
    "anchan": [
        71
    ],
    "atsang": [
        71
    ],
    "acipa, eastern": [
        72
    ],
    "acipa": [
        72,
        548
    ],
    "achipa": [
        72,
        548
    ],
    "acipanci": [
        72,
        548
    ],
    "arabic, ta’izzi-adeni spoken": [
        73
    ],
    "achi": [
        74,
        75,
        76
    ],
    "achi - cubulco": [
        75
    ],
    "achi - rabinal": [
        76
    ],
    "acroá": [
        77
    ],
    "achterhoeks": [
        78
    ],
    "aachterhoeks": [
        78
    ],
    "achterhoek": [
        78
    ],
    "achterhooks": [
        78
    ],
    "achuar-shiwiar": [
        79
    ],
    "achuár chícham": [
        79
    ],
    "achuár": [
        79
    ],
    "achiar chícham": [
        79
    ],
    "achiar": [
        79
    ],
    "achual": [
        79
    ],
    "achuale": [
        79
    ],
    "achuar": [
        79
    ],
    "achuar-shiviar": [
        79
    ],
    "achuar-shiwiara": [
        79
    ],
    "achuara": [
        79
    ],
    "achuare": [
        79
    ],
    "ashuar": [
        79
    ],
    "atchuara": [
        79
    ],
    "achumawi": [
        80
    ],
    "achomawi": [
        80
    ],
    "arabic, hijazi spoken": [
        81
    ],
    "arabian": [
        6756,
        8556,
        81,
        3063,
        6857,
        7084,
        7085
    ],
    "arabia": [
        81,
        409,
        426,
        431,
        451,
        6756,
        8556
    ],
    "arabic, omani spoken": [
        82
    ],
    "arabic, cypriot spoken": [
        83,
        84,
        85
    ],
    "acheron": [
        86
    ],
    "aceron": [
        86
    ],
    "achurun": [
        86
    ],
    "asheron": [
        86
    ],
    "adangme": [
        87
    ],
    "adaŋgbi": [
        87
    ],
    "atauran": [
        88
    ],
    "adabe": [
        88
    ],
    "ataura": [
        88
    ],
    "atauro": [
        88
    ],
    "atauru": [
        88
    ],
    "adere": [
        89
    ],
    "adiri": [
        89
    ],
    "arderi": [
        89
    ],
    "adele": [
        90
    ],
    "arabic, dhofari spoken": [
        91
    ],
    "andegerebinha": [
        92
    ],
    "andigibinha": [
        92
    ],
    "antekerrepenh": [
        92
    ],
    "antekerrepinhe": [
        92
    ],
    "au": [
        542,
        92,
        104,
        115,
        126,
        197,
        223,
        263,
        280,
        291,
        311,
        312,
        313,
        335,
        352,
        439,
        440,
        465,
        481,
        538,
        550,
        553,
        566,
        569,
        576,
        669,
        670,
        709,
        837,
        860,
        884,
        1035,
        1043,
        1213,
        1256,
        1257,
        1262,
        1283,
        1314,
        1560,
        1745,
        1756,
        1771,
        1776,
        1779,
        1825,
        1828,
        1830,
        1833,
        1835,
        1839,
        1841,
        1844,
        1849,
        1868,
        1869,
        1871,
        1875,
        1876,
        1877,
        1881,
        1883,
        1885,
        1899,
        1911,
        1960,
        1983,
        2027,
        2029,
        2032,
        2033,
        2037,
        2043,
        2046,
        2050,
        2079,
        2126,
        2252,
        2400,
        2541,
        2542,
        2559,
        2561,
        2566,
        2577,
        2582,
        2584,
        2594,
        2619,
        2620,
        2622,
        2638,
        2644,
        2657,
        2661,
        2664,
        2671,
        2682,
        2688,
        2696,
        2711,
        2714,
        2716,
        2718,
        2799,
        2807,
        2808,
        2817,
        2834,
        2840,
        2850,
        2854,
        2855,
        2859,
        2861,
        2869,
        3052,
        3117,
        3168,
        3171,
        3184,
        3194,
        3316,
        3317,
        3323,
        3326,
        3335,
        3367,
        3402,
        3431,
        3478,
        3482,
        3532,
        3534,
        3629,
        3636,
        3711,
        3752,
        3761,
        3767,
        3985,
        3988,
        4038,
        4039,
        4240,
        4241,
        4349,
        4355,
        4356,
        4366,
        4372,
        4383,
        4395,
        4430,
        4437,
        4478,
        4682,
        4691,
        4696,
        4727,
        4773,
        4985,
        4986,
        4991,
        4993,
        5161,
        5179,
        5188,
        5292,
        5306,
        5318,
        5344,
        5430,
        5445,
        5450,
        5470,
        5473,
        5497,
        5506,
        5557,
        5559,
        5579,
        5585,
        5591,
        5610,
        5613,
        5615,
        5670,
        5671,
        5679,
        5712,
        5714,
        5730,
        5750,
        5764,
        5767,
        5779,
        5794,
        5805,
        5806,
        5808,
        5810,
        5876,
        5894,
        6150,
        6159,
        6160,
        6166,
        6173,
        6205,
        6231,
        6245,
        6246,
        6343,
        6489,
        6527,
        6538,
        6541,
        6573,
        6592,
        6600,
        6604,
        6644,
        6645,
        7335,
        7371,
        7467,
        7470,
        7516,
        7523,
        7528,
        7530,
        7531,
        7869,
        7921,
        7943,
        7950,
        7959,
        7960,
        7965,
        7966,
        7971,
        7975,
        7994,
        7996,
        8036,
        8090,
        8100,
        8104,
        8105,
        8112,
        8115,
        8121,
        8164,
        8187,
        8191,
        8192,
        8198,
        8199,
        8200,
        8201,
        8205,
        8217,
        8219,
        8222,
        8223,
        8230,
        8231,
        8232,
        8233,
        8235,
        8236,
        8237,
        8238,
        8250,
        8252,
        8253,
        8257,
        8266,
        8272,
        8278,
        8283,
        8289,
        8295,
        8296,
        8301,
        8304,
        8323,
        8325,
        8326,
        8327,
        8328,
        8329,
        8330,
        8332,
        8334,
        8338,
        8341,
        8354,
        8360,
        8361,
        8367,
        8373,
        8376,
        8378,
        8381,
        8383,
        8384,
        8412,
        8415,
        8416,
        8417,
        8419,
        8423,
        8426,
        8443,
        8446,
        8463,
        8465,
        8466,
        8468,
        8470,
        8471,
        8490,
        8491,
        8538,
        8545,
        8546,
        8550,
        8554,
        8560,
        8562,
        8563,
        8570,
        8571,
        8588,
        8589,
        8591,
        8592,
        8594,
        8596,
        8598,
        8606,
        8608,
        8609,
        8610,
        8612,
        8617,
        8619,
        8625,
        8651,
        8665,
        8668,
        8673,
        8676,
        8679,
        8683,
        8692,
        8695,
        8696,
        8700,
        8701,
        8704,
        8707,
        8708,
        8709,
        8710,
        8712,
        8713,
        8764,
        8781,
        8782,
        8787,
        8788,
        8793,
        8795,
        8799,
        8800,
        8802,
        8836,
        8859,
        8897,
        8902,
        8918,
        8920,
        8946,
        8951,
        8954,
        8955,
        8956,
        8957,
        8958,
        8959,
        8960,
        8961,
        9018,
        9071,
        9081,
        9083,
        9084,
        9085,
        9087,
        9090,
        9091,
        9092,
        9093,
        9098,
        9100,
        9101,
        9102,
        9105,
        9111
    ],
    "australia": [
        5161,
        5613,
        8341,
        9081,
        92,
        104,
        115,
        126,
        197,
        223,
        263,
        280,
        291,
        311,
        312,
        313,
        335,
        352,
        439,
        440,
        465,
        481,
        538,
        550,
        553,
        566,
        569,
        576,
        669,
        670,
        709,
        837,
        860,
        884,
        1035,
        1043,
        1213,
        1256,
        1257,
        1262,
        1283,
        1314,
        1560,
        1745,
        1756,
        1771,
        1776,
        1779,
        1825,
        1828,
        1830,
        1833,
        1835,
        1839,
        1841,
        1844,
        1849,
        1868,
        1869,
        1871,
        1875,
        1876,
        1877,
        1881,
        1883,
        1885,
        1899,
        1911,
        1960,
        1983,
        2027,
        2029,
        2032,
        2033,
        2037,
        2043,
        2046,
        2050,
        2079,
        2126,
        2252,
        2400,
        2541,
        2542,
        2559,
        2561,
        2566,
        2577,
        2582,
        2584,
        2594,
        2619,
        2620,
        2622,
        2638,
        2644,
        2657,
        2661,
        2664,
        2671,
        2682,
        2688,
        2696,
        2711,
        2714,
        2716,
        2718,
        2799,
        2807,
        2808,
        2817,
        2834,
        2840,
        2850,
        2854,
        2855,
        2859,
        2861,
        2869,
        3052,
        3117,
        3168,
        3171,
        3184,
        3194,
        3316,
        3317,
        3323,
        3326,
        3335,
        3367,
        3402,
        3431,
        3478,
        3482,
        3532,
        3534,
        3629,
        3636,
        3711,
        3752,
        3761,
        3767,
        3985,
        3988,
        4038,
        4039,
        4240,
        4241,
        4349,
        4355,
        4356,
        4366,
        4372,
        4383,
        4395,
        4430,
        4437,
        4478,
        4682,
        4691,
        4696,
        4727,
        4773,
        4985,
        4986,
        4991,
        4993,
        5179,
        5188,
        5292,
        5306,
        5318,
        5344,
        5430,
        5445,
        5450,
        5470,
        5473,
        5497,
        5506,
        5557,
        5559,
        5579,
        5585,
        5591,
        5610,
        5615,
        5670,
        5671,
        5679,
        5712,
        5714,
        5730,
        5750,
        5764,
        5767,
        5779,
        5794,
        5805,
        5806,
        5808,
        5810,
        5876,
        5894,
        6150,
        6159,
        6160,
        6166,
        6173,
        6205,
        6231,
        6245,
        6246,
        6343,
        6489,
        6527,
        6538,
        6541,
        6573,
        6592,
        6600,
        6604,
        6644,
        6645,
        7335,
        7371,
        7467,
        7470,
        7516,
        7523,
        7528,
        7530,
        7531,
        7869,
        7921,
        7943,
        7950,
        7959,
        7960,
        7965,
        7966,
        7971,
        7975,
        7994,
        7996,
        8036,
        8090,
        8100,
        8104,
        8105,
        8112,
        8115,
        8121,
        8164,
        8187,
        8191,
        8192,
        8198,
        8199,
        8200,
        8201,
        8205,
        8217,
        8219,
        8222,
        8223,
        8230,
        8231,
        8232,
        8233,
        8235,
        8236,
        8237,
        8238,
        8250,
        8252,
        8253,
        8257,
        8266,
        8272,
        8278,
        8283,
        8289,
        8295,
        8296,
        8301,
        8304,
        8323,
        8325,
        8326,
        8327,
        8328,
        8329,
        8330,
        8332,
        8334,
        8338,
        8354,
        8360,
        8361,
        8367,
        8373,
        8376,
        8378,
        8381,
        8383,
        8384,
        8412,
        8415,
        8416,
        8417,
        8419,
        8423,
        8426,
        8443,
        8446,
        8463,
        8465,
        8466,
        8468,
        8470,
        8471,
        8490,
        8491,
        8538,
        8545,
        8546,
        8550,
        8554,
        8560,
        8562,
        8563,
        8570,
        8571,
        8588,
        8589,
        8591,
        8592,
        8594,
        8596,
        8598,
        8606,
        8608,
        8609,
        8610,
        8612,
        8617,
        8619,
        8625,
        8651,
        8665,
        8668,
        8673,
        8676,
        8679,
        8683,
        8692,
        8695,
        8696,
        8700,
        8701,
        8704,
        8707,
        8708,
        8709,
        8710,
        8712,
        8713,
        8764,
        8781,
        8782,
        8787,
        8788,
        8793,
        8795,
        8799,
        8800,
        8802,
        8836,
        8859,
        8897,
        8902,
        8918,
        8920,
        8946,
        8951,
        8954,
        8955,
        8956,
        8957,
        8958,
        8959,
        8960,
        8961,
        9018,
        9071,
        9083,
        9084,
        9085,
        9087,
        9090,
        9091,
        9092,
        9093,
        9098,
        9100,
        9101,
        9102,
        9105,
        9111
    ],
    "adhola": [
        93
    ],
    "adi": [
        94,
        97,
        95,
        4080,
        8247
    ],
    "abhor": [
        94,
        95
    ],
    "abor": [
        94,
        95
    ],
    "adi-bokar": [
        94,
        95
    ],
    "adioukrou": [
        96
    ],
    "adjukru": [
        96
    ],
    "adyoukrou": [
        96
    ],
    "adyukru": [
        96
    ],
    "ajukru": [
        96
    ],
    "adi, galo": [
        97
    ],
    "adi-gallong": [
        97
    ],
    "adi-galo": [
        97
    ],
    "adang": [
        98
    ],
    "alor": [
        357,
        98
    ],
    "adjora": [
        99
    ],
    "adjoria": [
        99
    ],
    "azao": [
        99
    ],
    "adangbe": [
        100
    ],
    "adan": [
        100
    ],
    "adantonwi": [
        100
    ],
    "agotime": [
        100
    ],
    "adonara": [
        101
    ],
    "adamorobe sign language": [
        102,
        103
    ],
    "adamorobe": [
        102,
        103
    ],
    "adasl": [
        102,
        103
    ],
    "adnyamathanha": [
        104
    ],
    "adynyamathanha": [
        104
    ],
    "ad’n’amadana": [
        104
    ],
    "anjimatana": [
        104
    ],
    "anjiwatana": [
        104
    ],
    "archualda": [
        104
    ],
    "atynyamatana": [
        104
    ],
    "aduge": [
        105
    ],
    "amundava": [
        106
    ],
    "amondawa": [
        106
    ],
    "amundawa": [
        106
    ],
    "amdo": [
        107
    ],
    "amdo tibetan": [
        107
    ],
    "anduo": [
        107
    ],
    "adyghe": [
        108,
        109,
        110,
        3481
    ],
    "adyge": [
        108,
        109,
        110
    ],
    "adygei": [
        108,
        109,
        110
    ],
    "adygey": [
        108,
        109,
        110
    ],
    "adəgăbză": [
        108,
        109,
        110
    ],
    "adzera": [
        111
    ],
    "acira": [
        111
    ],
    "atsera": [
        111
    ],
    "atzera": [
        111
    ],
    "azera": [
        111
    ],
    "avestan": [
        112,
        113,
        114
    ],
    "avesta": [
        112,
        113,
        114
    ],
    "areba": [
        115
    ],
    "a:rap": [
        115
    ],
    "araba": [
        115
    ],
    "ariba": [
        115
    ],
    "aripa": [
        115
    ],
    "arabic, tunisian spoken": [
        116,
        117
    ],
    "arabic, sa’idi spoken": [
        118
    ],
    "argentine sign language": [
        119
    ],
    "argentine": [
        119,
        2810
    ],
    "argentina": [
        119,
        2815,
        565,
        1337,
        1617,
        1620,
        2258,
        4961,
        5263,
        5920,
        6187,
        6358,
        6410,
        7416,
        7639,
        7947,
        8085,
        8267
    ],
    "ar": [
        119,
        565,
        1337,
        1617,
        1620,
        2258,
        4961,
        5263,
        5920,
        6187,
        6358,
        6410,
        7416,
        7639,
        7947,
        8085,
        8267
    ],
    "af": [
        1970,
        1003,
        120,
        139,
        212,
        470,
        1122,
        2330,
        2678,
        2853,
        2910,
        3253,
        3320,
        3729,
        4775,
        4946,
        5548,
        6057,
        6136,
        6284,
        6294,
        6299,
        6306,
        6313,
        6314,
        6752,
        6812,
        6827,
        7176,
        7533,
        7700,
        7711,
        8039,
        8044,
        8182,
        8184,
        8324,
        8352,
        8686
    ],
    "afghanistan": [
        120,
        139,
        212,
        470,
        1122,
        2330,
        2678,
        2853,
        2910,
        3253,
        3320,
        3729,
        4775,
        4946,
        5548,
        6057,
        6136,
        6284,
        6294,
        6299,
        6306,
        6313,
        6314,
        6752,
        6812,
        6827,
        7176,
        7533,
        7700,
        7711,
        8039,
        8044,
        8182,
        8184,
        8324,
        8352,
        8686
    ],
    "aeke": [
        121
    ],
    "ambele": [
        122
    ],
    "arem": [
        123
    ],
    "a-rem": [
        123
    ],
    "armenian sign language": [
        124
    ],
    "armenian": [
        124,
        3104,
        3105,
        3107,
        570,
        8432,
        6548
    ],
    "arsl": [
        124
    ],
    "am": [
        1011,
        124,
        570,
        3104,
        3105,
        3107,
        6548
    ],
    "armenia": [
        124,
        570,
        3104,
        3105,
        3107,
        6548
    ],
    "aer": [
        125
    ],
    "arrernte, eastern": [
        126
    ],
    "arrernte": [
        126
    ],
    "arunta": [
        126,
        440,
        569
    ],
    "aranda": [
        569,
        440,
        126
    ],
    "alsea": [
        127
    ],
    "akeu": [
        128
    ],
    "ake": [
        205,
        128
    ],
    "akheu": [
        128
    ],
    "aki": [
        128,
        804
    ],
    "akui": [
        128
    ],
    "ambakich": [
        129
    ],
    "aion": [
        129
    ],
    "amele": [
        130
    ],
    "amale": [
        130
    ],
    "aeka": [
        131
    ],
    "ajeka": [
        131
    ],
    "afrikaans": [
        132,
        133,
        134,
        135
    ],
    "africa": [
        132,
        133,
        134,
        1540,
        2224,
        2402,
        2406,
        2640,
        2673,
        3918,
        3924,
        4555,
        5427,
        5661,
        5662,
        5682,
        5695,
        5696,
        5940,
        6802,
        7127,
        7156,
        7613,
        7727,
        7728,
        8067,
        8068,
        8400,
        8452,
        8472,
        8473,
        8483,
        9172,
        9173
    ],
    "arabic, gulf spoken": [
        136
    ],
    "andai": [
        137
    ],
    "afghan sign language": [
        139
    ],
    "afghan": [
        139,
        6299,
        6306
    ],
    "afsl": [
        139
    ],
    "afghan sign": [
        139
    ],
    "afrihili": [
        140
    ],
    "akrukay": [
        141
    ],
    "aunda": [
        142
    ],
    "afakani": [
        143
    ],
    "afao": [
        144
    ],
    "afo": [
        144
    ],
    "afu": [
        144
    ],
    "aho": [
        144
    ],
    "afro-seminole creole": [
        146
    ],
    "afro-seminole": [
        146
    ],
    "afro-seminol criollo": [
        146
    ],
    "afro-seminol": [
        146
    ],
    "afitti": [
        147
    ],
    "affitti": [
        147
    ],
    "awutu": [
        148
    ],
    "aliki": [
        149,
        1066,
        2254
    ],
    "ati": [
        494,
        149,
        989,
        1066,
        3935,
        4015,
        7779
    ],
    "aguano": [
        150
    ],
    "aguanu": [
        150
    ],
    "ahuano": [
        150
    ],
    "awano": [
        150
    ],
    "awáno": [
        150
    ],
    "agbo": [
        151
    ],
    "agatu": [
        152
    ],
    "agarabi": [
        153
    ],
    "agarabe": [
        153
    ],
    "angal": [
        154,
        239,
        348
    ],
    "angal heneng": [
        239,
        154
    ],
    "arguni": [
        155,
        3236
    ],
    "argoeni": [
        155
    ],
    "angor": [
        156
    ],
    "anggor": [
        156
    ],
    "angba": [
        157
    ],
    "agariya": [
        158
    ],
    "agaria": [
        158
    ],
    "agharia": [
        158
    ],
    "agoria": [
        158
    ],
    "argobba": [
        159,
        160
    ],
    "agta, katubung": [
        161
    ],
    "agala": [
        162
    ],
    "angaataha": [
        163
    ],
    "angaatiha": [
        163
    ],
    "angaatiya": [
        163
    ],
    "angataha": [
        163
    ],
    "agutaynen": [
        164
    ],
    "agutayano": [
        164
    ],
    "agutayno": [
        164
    ],
    "agutaynon": [
        164
    ],
    "aghem": [
        166
    ],
    "aghɨ̂m": [
        166
    ],
    "awajún": [
        167
    ],
    "aents": [
        167
    ],
    "aguajún": [
        167
    ],
    "aguaruna": [
        167
    ],
    "ahuajún": [
        167
    ],
    "awajunt": [
        167
    ],
    "aage": [
        168
    ],
    "age": [
        168
    ],
    "agta, central cagayan": [
        169
    ],
    "awakateko": [
        170
    ],
    "aguacatec": [
        170
    ],
    "aguacateco": [
        170
    ],
    "anganiwai": [
        172,
        7171
    ],
    "anganiwei": [
        172,
        7171
    ],
    "aghul": [
        173
    ],
    "aghul-ch’al": [
        173
    ],
    "agiul shui": [
        173
    ],
    "agiul": [
        173
    ],
    "alta, southern": [
        174
    ],
    "alta": [
        174,
        400,
        5467,
        7318,
        1528,
        1669,
        8972,
        8986,
        8988,
        8990
    ],
    "agta, mt. iriga": [
        175
    ],
    "ahanta": [
        176
    ],
    "ayɩnda": [
        176
    ],
    "axamb": [
        177
    ],
    "ahamb": [
        177
    ],
    "aghu": [
        179,
        2799,
        3184
    ],
    "aizi, tiagbamrin": [
        180
    ],
    "aizi": [
        180,
        187,
        190
    ],
    "ahizi": [
        180,
        187,
        190
    ],
    "akha": [
        181,
        182,
        183,
        184,
        185
    ],
    "ahka": [
        181,
        182,
        183,
        184,
        185
    ],
    "aini": [
        181,
        182,
        183,
        184,
        185,
        195
    ],
    "aka": [
        7033,
        181,
        182,
        183,
        184,
        185,
        568,
        3054,
        3384,
        8365
    ],
    "ak’a": [
        181,
        182,
        183,
        184,
        185
    ],
    "achlo": [
        186
    ],
    "ago": [
        186
    ],
    "ahlon": [
        186
    ],
    "ahlon-bogo": [
        186
    ],
    "ahlõ": [
        186
    ],
    "ahonlan": [
        186
    ],
    "anlo": [
        186
    ],
    "aizi, mobumrin": [
        187
    ],
    "ahaan": [
        188
    ],
    "ahom": [
        189
    ],
    "aizi, aproumu": [
        190
    ],
    "aproumu": [
        190
    ],
    "apro": [
        190
    ],
    "aproin": [
        190
    ],
    "aprou": [
        190
    ],
    "aproumu aizi": [
        190
    ],
    "aprwe": [
        190
    ],
    "ahirani": [
        191
    ],
    "ahiri": [
        191
    ],
    "ashe": [
        192
    ],
    "ache": [
        8796,
        192
    ],
    "ala": [
        192,
        8269,
        8182
    ],
    "ahtena": [
        193
    ],
    "ahtna": [
        193
    ],
    "atna": [
        193
    ],
    "atnakenaege’": [
        193
    ],
    "arosi": [
        194
    ],
    "ainu": [
        195,
        208,
        209
    ],
    "ainu (china)": [
        195
    ],
    "aynu": [
        195
    ],
    "ainbai": [
        196
    ],
    "ainba": [
        196
    ],
    "alngith": [
        197
    ],
    "amara": [
        198
    ],
    "agi": [
        199
    ],
    "anguillan creole english": [
        200
    ],
    "anguillan": [
        200
    ],
    "antigua and barbuda creole english": [
        200
    ],
    "antigua": [
        200,
        2122
    ],
    "and": [
        4503,
        6051,
        7362,
        200,
        4106,
        4529,
        5453,
        5532,
        6660,
        344,
        1114,
        1115,
        1599,
        1607,
        2122,
        2171,
        2204,
        2211,
        2214,
        2219,
        2257,
        2454,
        2464,
        2481,
        3043,
        5309,
        5539,
        6286,
        6339,
        7089,
        7093,
        7217,
        7452,
        7705,
        8265
    ],
    "ag": [
        200,
        2122
    ],
    "antigua and barbuda": [
        200,
        2122
    ],
    "ai-cham": [
        201
    ],
    "atsam": [
        1376,
        201
    ],
    "assyrian neo-aramaic": [
        202,
        203
    ],
    "assyrian": [
        202,
        203
    ],
    "aisorski": [
        203
    ],
    "assyrianci": [
        203
    ],
    "assyriski": [
        203
    ],
    "aturaya swadaya": [
        203
    ],
    "aturaya": [
        203
    ],
    "aike": [
        205
    ],
    "akye": [
        205,
        492
    ],
    "aimele": [
        206
    ],
    "aimol": [
        207
    ],
    "ainu (japan)": [
        208,
        209
    ],
    "ainu itak": [
        208,
        209
    ],
    "aiton": [
        210
    ],
    "aitonia": [
        210
    ],
    "aimaq": [
        212
    ],
    "airoran": [
        213
    ],
    "adora": [
        213
    ],
    "aeroran": [
        213
    ],
    "arikem": [
        214
    ],
    "ahopovo": [
        214
    ],
    "ahôpovo": [
        214
    ],
    "ariken": [
        214
    ],
    "arikém": [
        214
    ],
    "ariqueme": [
        214
    ],
    "ariquemes": [
        214
    ],
    "ariquême": [
        214
    ],
    "aari": [
        215,
        216,
        217
    ],
    "aighon": [
        218
    ],
    "aigon": [
        218
    ],
    "ali": [
        219,
        8820
    ],
    "african": [
        2539,
        2540,
        6802,
        568,
        1023,
        1807,
        3466,
        3490,
        3518,
        5424,
        5571,
        6249,
        219,
        649,
        704,
        747,
        754,
        874,
        890,
        893,
        948,
        1028,
        1060,
        1212,
        1821,
        2427,
        2545,
        2555,
        2556,
        2560,
        2583,
        2608,
        2722,
        2792,
        2862,
        3969,
        4037,
        4144,
        4347,
        4421,
        4423,
        4431,
        4648,
        4665,
        4753,
        5277,
        5320,
        5382,
        5426,
        5816,
        6717,
        6804,
        6999,
        7078,
        7934,
        8046,
        8727,
        8826,
        8932
    ],
    "aja": [
        220,
        221,
        228
    ],
    "adja": [
        220,
        221
    ],
    "aja (south sudan)": [
        220
    ],
    "ajja": [
        220
    ],
    "ajagbe": [
        221
    ],
    "aja (benin)": [
        221
    ],
    "ajië": [
        222
    ],
    "anjie": [
        222
    ],
    "a’jie": [
        222
    ],
    "andajin": [
        223
    ],
    "andidja": [
        223
    ],
    "andidjara": [
        223
    ],
    "arabic, south levantine spoken": [
        224
    ],
    "arabic, judeo-tunisian": [
        225,
        226
    ],
    "arabic, judeo-moroccan": [
        227,
        3421
    ],
    "ajawa": [
        228,
        8733,
        8734
    ],
    "ajanci": [
        228
    ],
    "amri karbi": [
        229
    ],
    "amri": [
        229
    ],
    "akan": [
        230,
        231
    ],
    "angkola": [
        232,
        233
    ],
    "anakola": [
        232,
        233
    ],
    "amberbaken": [
        234
    ],
    "akpet-ehom": [
        235
    ],
    "akawaio": [
        236
    ],
    "acahuayo": [
        236
    ],
    "acawayo": [
        236
    ],
    "acewaio": [
        236
    ],
    "akawai": [
        236
    ],
    "akawayo": [
        236
    ],
    "akwaio": [
        236
    ],
    "akpa": [
        237
    ],
    "akweya": [
        237
    ],
    "anakalangu": [
        238
    ],
    "anakalang": [
        238
    ],
    "agarar": [
        239
    ],
    "augu": [
        239
    ],
    "aiome": [
        240
    ],
    "aren": [
        240
    ],
    "ayom": [
        240
    ],
    "aka-jeru": [
        241
    ],
    "akkadian": [
        242
    ],
    "aklanon": [
        243
    ],
    "akeanon": [
        243
    ],
    "aklan": [
        243
    ],
    "aklano": [
        243
    ],
    "aklanon-bisayan": [
        243
    ],
    "aka-bo": [
        244
    ],
    "akurio": [
        245
    ],
    "akoerio": [
        245
    ],
    "akuliyo": [
        245
    ],
    "akuri": [
        245
    ],
    "akurijo": [
        245
    ],
    "akuriyo": [
        245
    ],
    "akpafu-lolobi": [
        246
    ],
    "ak": [
        247
    ],
    "araki": [
        248
    ],
    "akaselem": [
        249
    ],
    "akasele": [
        249
    ],
    "akolet": [
        250
    ],
    "akum": [
        251,
        3540
    ],
    "aakuem": [
        251
    ],
    "anyar": [
        251
    ],
    "akhvakh": [
        252
    ],
    "ashvado": [
        252
    ],
    "axvax": [
        252
    ],
    "ašwałi": [
        252
    ],
    "ašwałi mic̣i": [
        252
    ],
    "akwa": [
        253,
        6228,
        2241
    ],
    "aka-kede": [
        254
    ],
    "aka-kol": [
        255
    ],
    "alabama": [
        256
    ],
    "albaamo": [
        256
    ],
    "albaamo innaaɬiilka": [
        256
    ],
    "alibamu": [
        256
    ],
    "alago": [
        257
    ],
    "arago": [
        257
    ],
    "aragu": [
        257
    ],
    "argo": [
        257
    ],
    "alacalouf": [
        258
    ],
    "alacaluf": [
        258
    ],
    "alacalufe": [
        258
    ],
    "alaculoof": [
        258
    ],
    "alaculuf": [
        258
    ],
    "alakaluf": [
        258
    ],
    "alikaluf": [
        258
    ],
    "alikhoolip": [
        258
    ],
    "alikuluf": [
        258
    ],
    "alilkoolif": [
        258
    ],
    "alokolup": [
        258
    ],
    "alooculoof": [
        258
    ],
    "alookooloop": [
        258
    ],
    "alucaluf": [
        258
    ],
    "alukoeluf": [
        258
    ],
    "alukulup": [
        258
    ],
    "alladian": [
        259
    ],
    "aladian": [
        259
    ],
    "alladyan": [
        259
    ],
    "allagia": [
        259
    ],
    "allagian": [
        259
    ],
    "aleut": [
        260,
        261,
        5129,
        2111,
        2112
    ],
    "anangax": [
        260,
        261
    ],
    "alege": [
        262
    ],
    "alegi": [
        262
    ],
    "alawa": [
        263,
        8181
    ],
    "alaua": [
        263
    ],
    "allaura": [
        263
    ],
    "allawa": [
        263
    ],
    "allowa": [
        263
    ],
    "allowiri": [
        263
    ],
    "allua": [
        263
    ],
    "alowa": [
        263
    ],
    "amaimon": [
        264
    ],
    "alangan": [
        265
    ],
    "alak": [
        266
    ],
    "allar": [
        267,
        2575,
        2576
    ],
    "aalan": [
        267
    ],
    "alan": [
        267
    ],
    "alanmar": [
        267
    ],
    "alar": [
        267
    ],
    "allan": [
        267
    ],
    "amblong": [
        268
    ],
    "albanian, gheg": [
        269,
        270
    ],
    "al": [
        270,
        7068,
        7069,
        7070,
        7073,
        7077
    ],
    "albania": [
        270,
        7068,
        7069,
        7070,
        7073,
        7077
    ],
    "alune": [
        272
    ],
    "alfoeren": [
        272
    ],
    "algonquin": [
        273
    ],
    "anicinàbemowin": [
        273
    ],
    "algonkin": [
        273
    ],
    "alutor": [
        274
    ],
    "aliutor": [
        274
    ],
    "alyutor": [
        274
    ],
    "altai, southern": [
        275,
        276
    ],
    "altai": [
        275,
        276,
        505
    ],
    "areare": [
        277
    ],
    "alaba-k’abeena": [
        278
    ],
    "amol": [
        279
    ],
    "alatil": [
        279
    ],
    "aru": [
        279,
        3418,
        8580,
        572,
        575
    ],
    "alyawarr": [
        280
    ],
    "aljawara": [
        280
    ],
    "alyawarra": [
        280
    ],
    "alyawarre": [
        280
    ],
    "alur": [
        281
    ],
    "aloro": [
        281
    ],
    "alua": [
        281
    ],
    "alulu": [
        281
    ],
    "amharic": [
        282,
        283,
        284
    ],
    "amanayé": [
        285
    ],
    "amanage": [
        285
    ],
    "amanaié": [
        285
    ],
    "amanajé": [
        285
    ],
    "amanajó": [
        285
    ],
    "amanyé": [
        285
    ],
    "ararandeuara": [
        285
    ],
    "ambo": [
        286,
        5420
    ],
    "amahuaca": [
        287
    ],
    "amaguaco": [
        287
    ],
    "amahuaka": [
        287
    ],
    "amajuaca": [
        287
    ],
    "amawaca": [
        287
    ],
    "amawaka": [
        287
    ],
    "amawáka": [
        287
    ],
    "amenguaca": [
        287
    ],
    "ameuhaque": [
        287
    ],
    "amagues": [
        288
    ],
    "amagé": [
        288
    ],
    "amajé": [
        288
    ],
    "amajó": [
        288
    ],
    "amoishe": [
        288
    ],
    "amueixa": [
        288
    ],
    "amuese": [
        288
    ],
    "amuesha": [
        288
    ],
    "amueshua": [
        288
    ],
    "amuetamo": [
        288
    ],
    "amurdak": [
        291
    ],
    "amarag": [
        291
    ],
    "amarak": [
        291
    ],
    "amardak": [
        291
    ],
    "amurag": [
        291
    ],
    "amurdag": [
        291
    ],
    "amurrag": [
        291
    ],
    "amurrak": [
        291
    ],
    "amurtak": [
        291
    ],
    "amuruk": [
        291
    ],
    "a’moordiyu": [
        291
    ],
    "amis": [
        292,
        293
    ],
    "ami": [
        312,
        292
    ],
    "amia": [
        292
    ],
    "amdang": [
        294
    ],
    "andang": [
        294
    ],
    "andangti": [
        294
    ],
    "amdangtii": [
        294
    ],
    "ambai": [
        295
    ],
    "ambai-menawi": [
        295
    ],
    "amwi": [
        296
    ],
    "ama": [
        5795,
        297
    ],
    "ama (papua new guinea)": [
        297
    ],
    "awai": [
        298
    ],
    "amanab": [
        298
    ],
    "amo": [
        299
    ],
    "amap": [
        299
    ],
    "amon": [
        299,
        7962
    ],
    "among": [
        299
    ],
    "alamblak": [
        300
    ],
    "arambak": [
        300
    ],
    "amahai": [
        301
    ],
    "amahei": [
        301
    ],
    "amarakaeri": [
        302
    ],
    "aratbuten huaʼa": [
        302
    ],
    "aratbuten": [
        302
    ],
    "amaracaire": [
        302
    ],
    "amarakaire": [
        302
    ],
    "arakmbut": [
        302
    ],
    "arakmbut háte": [
        302
    ],
    "aratbuten hua’a": [
        302
    ],
    "amami-oshima, southern": [
        303
    ],
    "amami-oshima": [
        303,
        6646,
        3385
    ],
    "amami-osima": [
        303,
        6646
    ],
    "amto": [
        304
    ],
    "amuzgo, guerrero": [
        305
    ],
    "amuzgo": [
        305,
        603,
        604
    ],
    "amuzgo de guerrero": [
        305
    ],
    "ambelau": [
        306
    ],
    "amblau": [
        306
    ],
    "aramaic": [
        435,
        436,
        437,
        438,
        3416,
        5824,
        6668,
        6669,
        6670,
        7605,
        307,
        308,
        309,
        310,
        7268
    ],
    "arab": [
        307,
        308,
        309,
        310,
        368,
        407,
        430,
        437,
        2121,
        2459,
        4320,
        5824,
        7136,
        7920
    ],
    "anmatyerre": [
        311
    ],
    "anmatjirra": [
        311
    ],
    "anmatyerr": [
        311
    ],
    "ame": [
        312
    ],
    "amijangal": [
        312
    ],
    "atampaya": [
        313
    ],
    "atambaya": [
        313
    ],
    "aragonese": [
        314
    ],
    "altoaragonés": [
        314
    ],
    "aragoieraz": [
        314
    ],
    "aragonés": [
        314
    ],
    "aragonesa": [
        314
    ],
    "andaqui": [
        315
    ],
    "aguanunga": [
        315
    ],
    "andaki": [
        315
    ],
    "andaquí": [
        315
    ],
    "andoa": [
        316
    ],
    "andoa-shimigae": [
        316
    ],
    "angas": [
        317
    ],
    "ansus": [
        318
    ],
    "anesu": [
        319
    ],
    "animere": [
        320
    ],
    "anyimere": [
        320
    ],
    "angaua": [
        322
    ],
    "andi": [
        323
    ],
    "andii": [
        323
    ],
    "andiy": [
        323
    ],
    "anor": [
        324
    ],
    "ankwai": [
        325
    ],
    "ankwe": [
        325
    ],
    "ankwei": [
        325
    ],
    "anu-khongso": [
        326
    ],
    "anu-hkongso chin": [
        326
    ],
    "anu-hkongso": [
        326
    ],
    "anal": [
        327
    ],
    "andone": [
        328
    ],
    "andoni": [
        328
    ],
    "andonni": [
        328
    ],
    "andoque": [
        329
    ],
    "andoke": [
        329
    ],
    "angika": [
        330
    ],
    "anga": [
        330,
        2888
    ],
    "angikar": [
        330
    ],
    "andh": [
        333
    ],
    "andha": [
        333
    ],
    "andhi": [
        333
    ],
    "anserma": [
        334
    ],
    "ancerma": [
        334
    ],
    "anserna": [
        334
    ],
    "antikarinya": [
        335
    ],
    "andagarinya": [
        335
    ],
    "antakarinya": [
        335
    ],
    "antakirinya": [
        335
    ],
    "anuak": [
        336,
        337,
        338
    ],
    "anyuaa": [
        336,
        337,
        338
    ],
    "anywak": [
        337,
        338,
        336
    ],
    "anywaa": [
        337,
        338,
        336
    ],
    "anyuak": [
        337,
        338
    ],
    "anywa": [
        337,
        338
    ],
    "agnang": [
        339
    ],
    "anyah": [
        339
    ],
    "anyan": [
        339
    ],
    "anyang": [
        339
    ],
    "anaang": [
        340
    ],
    "anaañ": [
        340
    ],
    "anang": [
        340
    ],
    "annang": [
        340
    ],
    "andra-hus": [
        341
    ],
    "ahus": [
        341
    ],
    "anyin": [
        342,
        5102
    ],
    "agni": [
        342
    ],
    "agni sanvi": [
        342
    ],
    "agny": [
        342
    ],
    "anyi": [
        342
    ],
    "anem": [
        343
    ],
    "angolar": [
        344
    ],
    "abom": [
        345
    ],
    "andarum": [
        347
    ],
    "angal enen": [
        348
    ],
    "alauagat": [
        349
    ],
    "angoram": [
        350
    ],
    "arma": [
        351
    ],
    "anindilyakwa": [
        352
    ],
    "andiljangwa": [
        352
    ],
    "andilyaugwa": [
        352
    ],
    "aninhdhilyagwa": [
        352
    ],
    "arhö": [
        356
    ],
    "aro": [
        7417,
        356
    ],
    "alorese": [
        357
    ],
    "aomie": [
        358
    ],
    "aore": [
        360
    ],
    "arso": [
        361
    ],
    "atong": [
        362,
        363,
        498
    ],
    "a'tong": [
        362,
        363
    ],
    "atong (india)": [
        362,
        363
    ],
    "attong": [
        362,
        363
    ],
    "a’tong": [
        362,
        363
    ],
    "a’ou": [
        364
    ],
    "a'ou": [
        364
    ],
    "auo": [
        364
    ],
    "awou": [
        364
    ],
    "atorada": [
        365
    ],
    "atorad": [
        365
    ],
    "atorai": [
        365
    ],
    "ator’ti": [
        365
    ],
    "atoni": [
        366,
        908
    ],
    "apae’aa": [
        367
    ],
    "arabic, north levantine spoken": [
        368
    ],
    "arabic, sudanese spoken": [
        369,
        370
    ],
    "agta, pahanan": [
        374
    ],
    "ampanang": [
        375
    ],
    "athpariya": [
        376,
        1293
    ],
    "arthare": [
        376,
        6454
    ],
    "athaphre": [
        376
    ],
    "athapre": [
        376
    ],
    "athpahariya": [
        376,
        1293
    ],
    "athpare": [
        376,
        1293
    ],
    "athpre": [
        376
    ],
    "apiaká": [
        377
    ],
    "apiacá": [
        377
    ],
    "apiake": [
        377
    ],
    "apache, jicarilla": [
        378
    ],
    "apache": [
        378,
        379,
        380,
        381,
        391
    ],
    "abáachi mizaa": [
        378
    ],
    "abáachi": [
        378
    ],
    "apache, kiowa": [
        379
    ],
    "apache, lipan": [
        380
    ],
    "apache, mescalero-chiricahua": [
        381
    ],
    "apinayé": [
        382
    ],
    "afotigé": [
        382
    ],
    "aogé": [
        382
    ],
    "apinagé": [
        382
    ],
    "apinaié": [
        382
    ],
    "apinajé": [
        382
    ],
    "ambul": [
        383
    ],
    "apalik": [
        383
    ],
    "apma": [
        384
    ],
    "abma": [
        384
    ],
    "a-pucikwar": [
        385
    ],
    "aka-pujjukar": [
        385
    ],
    "arop-lokep": [
        386
    ],
    "arop-lukep": [
        386
    ],
    "arop": [
        387
    ],
    "arop-sissano": [
        387
    ],
    "apatani": [
        388
    ],
    "apa": [
        388
    ],
    "apurinã": [
        389,
        6143
    ],
    "alapmunte": [
        390
    ],
    "apache, western": [
        391
    ],
    "aputai": [
        392
    ],
    "apalaí": [
        393
    ],
    "apalay": [
        393
    ],
    "aparaí": [
        393,
        8173
    ],
    "arakwayu": [
        393
    ],
    "ambari": [
        394
    ],
    "ampale": [
        394
    ],
    "ampeeli": [
        394
    ],
    "ampeeli-wojokeso": [
        394
    ],
    "ampele": [
        394
    ],
    "archi": [
        395
    ],
    "archib": [
        395
    ],
    "archin": [
        395
    ],
    "archintsy": [
        395
    ],
    "archsel": [
        395
    ],
    "arshashdib": [
        395
    ],
    "ampari": [
        396
    ],
    "ambeenge": [
        396
    ],
    "ampari dogon": [
        396
    ],
    "arigidi": [
        397
    ],
    "akoko": [
        397
    ],
    "aninka": [
        398
    ],
    "atohwaim": [
        399
    ],
    "alta, northern": [
        400
    ],
    "atakapa": [
        401
    ],
    "arhâ": [
        402
    ],
    "ara": [
        402,
        7363
    ],
    "angaité": [
        403
    ],
    "akuntsu": [
        404
    ],
    "akunsu": [
        404
    ],
    "akuntsun": [
        404
    ],
    "akuntsú": [
        404
    ],
    "akunt’su": [
        404
    ],
    "ae": [
        7331,
        407,
        2121,
        7136
    ],
    "al-’arabiyya": [
        409,
        426
    ],
    "arabic, standard": [
        409,
        426
    ],
    "arabana": [
        439
    ],
    "arabunna": [
        439
    ],
    "arrarnta, western": [
        440
    ],
    "arrarnta": [
        440
    ],
    "arrente": [
        440
    ],
    "arhuaco": [
        441
    ],
    "arauco": [
        441
    ],
    "arhuac": [
        441
    ],
    "aruac": [
        441
    ],
    "aruaco": [
        441,
        454
    ],
    "arwako": [
        441
    ],
    "auroguac": [
        441
    ],
    "arikara": [
        442
    ],
    "arikaree": [
        442
    ],
    "arikari": [
        442
    ],
    "arikaris": [
        442
    ],
    "arapaso": [
        443
    ],
    "arapaço": [
        443
    ],
    "araspaso": [
        443
    ],
    "arikapú": [
        444
    ],
    "aricapú": [
        444
    ],
    "arabela": [
        445
    ],
    "araucana": [
        446
    ],
    "araona": [
        447
    ],
    "arapaho": [
        448
    ],
    "arrapahoe": [
        448
    ],
    "arabic, algerian spoken": [
        449
    ],
    "algerian arabic": [
        449
    ],
    "arara tupi": [
        450
    ],
    "arara": [
        450,
        567,
        3426,
        4628
    ],
    "arara-karo": [
        450
    ],
    "arára de rondonia": [
        450
    ],
    "arára do jiparaná": [
        450
    ],
    "arabic, najdi spoken": [
        451
    ],
    "aruá (amazonas state)": [
        452
    ],
    "aruá": [
        452,
        455
    ],
    "amazonas": [
        452,
        6403
    ],
    "arawá": [
        452
    ],
    "arbore": [
        453
    ],
    "arawak": [
        454
    ],
    "araguaco": [
        454
    ],
    "arahuaco": [
        454
    ],
    "arahuacos": [
        454
    ],
    "arawac": [
        454
    ],
    "arhwak": [
        454
    ],
    "arowak": [
        454
    ],
    "arrowukas": [
        454
    ],
    "aruak": [
        454
    ],
    "aruaqui": [
        454
    ],
    "arwuak": [
        454
    ],
    "arouá": [
        455
    ],
    "arouén": [
        455
    ],
    "aruá (rodonia state)": [
        455
    ],
    "arabic, moroccan spoken": [
        456
    ],
    "arabic, egyptian spoken": [
        457,
        458
    ],
    "assamese": [
        459,
        5288
    ],
    "asambe": [
        459
    ],
    "asami": [
        459
    ],
    "asamiya": [
        459
    ],
    "asu": [
        460,
        520
    ],
    "ashu": [
        460,
        1636,
        1637
    ],
    "asu (tanzania)": [
        460
    ],
    "athu": [
        460
    ],
    "assiniboine": [
        461
    ],
    "assiniboin": [
        461
    ],
    "asmat, casuarina coast": [
        462
    ],
    "asmat": [
        462,
        483,
        1554,
        5529,
        7600,
        7856
    ],
    "as-amat": [
        462,
        483
    ],
    "american sign language": [
        463,
        464,
        6315
    ],
    "american": [
        463,
        464,
        2118,
        6315,
        1329,
        6310,
        2124
    ],
    "asl": [
        463,
        464,
        6315
    ],
    "ameslan": [
        463,
        464
    ],
    "américaine": [
        463,
        464
    ],
    "america": [
        463,
        464,
        2257
    ],
    "auslan": [
        465
    ],
    "australian sign language": [
        465
    ],
    "australian": [
        481,
        2126,
        465,
        3250
    ],
    "agwara kambari": [
        466
    ],
    "agwara": [
        466
    ],
    "aschingini": [
        466
    ],
    "ashaganna": [
        466
    ],
    "ashingini": [
        466,
        7749
    ],
    "awishira": [
        467
    ],
    "abigira": [
        467
    ],
    "abiquira": [
        467
    ],
    "abishira": [
        467
    ],
    "aewa": [
        467
    ],
    "agouisiri": [
        467
    ],
    "auishiri": [
        467
    ],
    "avirxiri": [
        467
    ],
    "aʔɨwa": [
        467
    ],
    "asianara": [
        468
    ],
    "asienara": [
        468
    ],
    "akweto": [
        469
    ],
    "ashkun": [
        470
    ],
    "ashkund": [
        470
    ],
    "ashkuni": [
        470
    ],
    "ashkunu viri": [
        470
    ],
    "ashkunu": [
        470
    ],
    "asilulu": [
        471
    ],
    "asurini of xingú": [
        472
    ],
    "asurini": [
        472,
        479
    ],
    "assurinikin": [
        472
    ],
    "assuriní": [
        472,
        479
    ],
    "asurini do xingú": [
        472
    ],
    "asuriní de koatinema": [
        472
    ],
    "asuriní": [
        472,
        479
    ],
    "awaeté": [
        472,
        6027
    ],
    "awaté": [
        472
    ],
    "asaro": [
        473
    ],
    "algerian sign language": [
        474
    ],
    "algérienne": [
        474
    ],
    "alesharh": [
        474
    ],
    "aljza’er": [
        474
    ],
    "austrian sign language": [
        475
    ],
    "austrian": [
        475,
        625
    ],
    "at": [
        475,
        625,
        1783,
        2125
    ],
    "austria": [
        475,
        625,
        1783,
        2125
    ],
    "asuri": [
        476
    ],
    "ashree": [
        476
    ],
    "assur": [
        476
    ],
    "asura": [
        476
    ],
    "assumbo": [
        477
    ],
    "asumbo": [
        477,
        7929
    ],
    "asturian": [
        478
    ],
    "asturianu": [
        478
    ],
    "astur-leonese": [
        478
    ],
    "asturian-leonese": [
        478
    ],
    "asturleonese": [
        478
    ],
    "asurini, tocantins": [
        479
    ],
    "akwawa": [
        479
    ],
    "akwawa-asuriní": [
        479
    ],
    "akwaya": [
        479
    ],
    "asuriní do tocantins": [
        479
    ],
    "asuriní do trocará": [
        479
    ],
    "asoa": [
        480
    ],
    "asua": [
        480
    ],
    "asuae": [
        480
    ],
    "asuati": [
        480
    ],
    "australian aborigines sign language": [
        481
    ],
    "aborigines": [
        481
    ],
    "asat": [
        482
    ],
    "asmat, yaosakor": [
        483
    ],
    "as": [
        484,
        2124
    ],
    "ata": [
        496,
        489,
        485
    ],
    "aci": [
        486,
        487
    ],
    "aji": [
        486,
        487,
        598,
        2955
    ],
    "atshi": [
        486,
        487
    ],
    "atsi": [
        486,
        487
    ],
    "atsi-maru": [
        486,
        487
    ],
    "atzi": [
        486,
        487
    ],
    "azi": [
        486,
        487
    ],
    "atsahuaca": [
        488
    ],
    "ata manobo": [
        489
    ],
    "ata of davao": [
        489
    ],
    "atao manobo": [
        489
    ],
    "atao": [
        489
    ],
    "atemble": [
        490
    ],
    "atemple": [
        490
    ],
    "atemple-apris": [
        490
    ],
    "attié": [
        492
    ],
    "akie": [
        492,
        5878
    ],
    "atche": [
        492
    ],
    "atie": [
        492
    ],
    "atshe": [
        492
    ],
    "atikamekw": [
        493
    ],
    "atihkamekw": [
        493
    ],
    "atikamek": [
        493
    ],
    "attikamek": [
        493
    ],
    "attimewk": [
        493
    ],
    "agta, mt. iraya": [
        495
    ],
    "ashtiani": [
        497
    ],
    "ashtiyani": [
        497
    ],
    "astiani": [
        497
    ],
    "atong (cameroon)": [
        498
    ],
    "atta, pudtol": [
        499
    ],
    "atta": [
        499,
        503,
        607
    ],
    "aralle-tabulahan": [
        500
    ],
    "atroahy": [
        501
    ],
    "atroahí": [
        501
    ],
    "atroarí": [
        501
    ],
    "atroaí": [
        501
    ],
    "atrowari": [
        501
    ],
    "atruahí": [
        501
    ],
    "aane": [
        502
    ],
    "ahahnelin": [
        502
    ],
    "ahe": [
        502
    ],
    "ananin": [
        502
    ],
    "atsina": [
        502
    ],
    "a’ananin": [
        502
    ],
    "atta, pamplona": [
        503
    ],
    "atuot": [
        504
    ],
    "atwot": [
        504
    ],
    "altai, northern": [
        505
    ],
    "atsugewi": [
        506
    ],
    "arutani": [
        507
    ],
    "anake": [
        507
    ],
    "aoaqui": [
        507
    ],
    "auakê": [
        507
    ],
    "auaqué": [
        507
    ],
    "awaikê": [
        507
    ],
    "awake": [
        507
    ],
    "awaké": [
        507
    ],
    "aneityum": [
        508
    ],
    "aneiteum": [
        508
    ],
    "aneiteumese": [
        508
    ],
    "anejom": [
        508
    ],
    "anejom̃": [
        508
    ],
    "antas anejom̃": [
        508
    ],
    "antas": [
        508
    ],
    "arta": [
        509
    ],
    "asumboa": [
        510
    ],
    "asubuo": [
        510
    ],
    "asumbua": [
        510
    ],
    "asumuo": [
        510
    ],
    "alugu": [
        511
    ],
    "auca": [
        512
    ],
    "anuta": [
        513
    ],
    "anutan": [
        513
    ],
    "aguna": [
        514
    ],
    "aguna-gbe": [
        514
    ],
    "agunaco": [
        514
    ],
    "agunagbe": [
        514
    ],
    "agunaný": [
        514
    ],
    "awuna": [
        514
    ],
    "aushi": [
        515
    ],
    "avaushi": [
        515
    ],
    "anuki": [
        516
    ],
    "awjilah": [
        517
    ],
    "aoudjila": [
        517
    ],
    "augila": [
        517
    ],
    "aujila": [
        517
    ],
    "awjila": [
        517
    ],
    "awjili": [
        517
    ],
    "arima": [
        518
    ],
    "arinua": [
        518
    ],
    "arinwa": [
        518
    ],
    "aulua": [
        519
    ],
    "aulua bay": [
        519
    ],
    "abewa": [
        520
    ],
    "asu (nigeria)": [
        520
    ],
    "aunalei": [
        521,
        5858,
        5880,
        5926,
        5931,
        5978
    ],
    "auyokawa": [
        522
    ],
    "adulu": [
        523
    ],
    "atura": [
        523
    ],
    "aturu": [
        523
    ],
    "anus": [
        524
    ],
    "aruek": [
        525
    ],
    "austral": [
        526
    ],
    "auye": [
        527
    ],
    "auwje": [
        527
    ],
    "awyi": [
        528
    ],
    "awje": [
        528
    ],
    "awji": [
        528
    ],
    "awye": [
        528
    ],
    "aurá": [
        529
    ],
    "auré": [
        529
    ],
    "awiyaana": [
        530
    ],
    "auyana": [
        530
    ],
    "arabic, uzbeki spoken": [
        531
    ],
    "avar": [
        532,
        5825
    ],
    "avaric": [
        532
    ],
    "avaro": [
        532
    ],
    "avau": [
        533
    ],
    "awau": [
        533
    ],
    "alviri-vidari": [
        534
    ],
    "avikam": [
        535
    ],
    "avekom": [
        535
    ],
    "arabic, eastern egyptian bedawi spoken": [
        537
    ],
    "arabic, levantine bedawi spoken": [
        537
    ],
    "angkamuthi": [
        538
    ],
    "anggamudi": [
        538
    ],
    "ankamuti": [
        538
    ],
    "avatime": [
        539
    ],
    "afatime": [
        539
    ],
    "agavotaguerra": [
        540
    ],
    "agavotocueng": [
        540
    ],
    "agavotokueng": [
        540
    ],
    "agavotoqueng": [
        540
    ],
    "aushiri": [
        541
    ],
    "abijira": [
        541
    ],
    "auxira": [
        541
    ],
    "awshira": [
        541
    ],
    "a’éwa": [
        541
    ],
    "avokaya": [
        543,
        544
    ],
    "abukeia": [
        543
    ],
    "avukaya": [
        543
    ],
    "avá-canoeiro": [
        545
    ],
    "abá": [
        545
    ],
    "avá": [
        545,
        2831,
        6341
    ],
    "awana": [
        545
    ],
    "awadhi": [
        546
    ],
    "abadhi": [
        546
    ],
    "abadi": [
        3498,
        546,
        7805
    ],
    "abohi": [
        546
    ],
    "ambodhi": [
        546
    ],
    "avadhi": [
        546
    ],
    "awa": [
        547,
        8146,
        880,
        1538,
        4081,
        7993,
        8032
    ],
    "awa (papua new guinea)": [
        547
    ],
    "awetí": [
        549
    ],
    "arauine": [
        549
    ],
    "arauite": [
        549
    ],
    "auetí": [
        549
    ],
    "auetó": [
        549
    ],
    "auití": [
        549
    ],
    "autl": [
        549
    ],
    "awetö": [
        549
    ],
    "anguthimri": [
        550
    ],
    "angadimi": [
        550
    ],
    "angutimi": [
        550,
        2850
    ],
    "awbono": [
        551
    ],
    "aekyom": [
        552
    ],
    "aiwin": [
        552
    ],
    "akium": [
        552
    ],
    "awin": [
        552
    ],
    "awabakal": [
        553
    ],
    "awabagal": [
        553
    ],
    "awabakalkoba": [
        553
    ],
    "arawum": [
        554
    ],
    "awngi": [
        555
    ],
    "awak": [
        556
    ],
    "awok": [
        556
    ],
    "awera": [
        557
    ],
    "awyu, south": [
        558
    ],
    "awyu": [
        558,
        560,
        561,
        564,
        6308,
        8807
    ],
    "araweté": [
        559
    ],
    "araueté": [
        559
    ],
    "arawine": [
        559
    ],
    "awyu, central": [
        560
    ],
    "ajau": [
        560
    ],
    "auyu": [
        560
    ],
    "avio": [
        560
    ],
    "awju": [
        560
    ],
    "awya": [
        560
    ],
    "awyu, jair": [
        561
    ],
    "awun": [
        562
    ],
    "auwon": [
        562
    ],
    "awon": [
        562
    ],
    "awara": [
        563
    ],
    "awyu, edera": [
        564
    ],
    "abipon": [
        565
    ],
    "ayerrerenge": [
        566
    ],
    "aroinga": [
        566
    ],
    "arára, mato grosso": [
        567
    ],
    "arara do aripuanã": [
        567
    ],
    "aripuanã": [
        567
    ],
    "arara do beiradão": [
        567
    ],
    "arara do rio branco": [
        567
    ],
    "aranda, lower southern": [
        569
    ],
    "aldolanga": [
        569
    ],
    "aldolinga": [
        569
    ],
    "alitera": [
        569
    ],
    "aranta": [
        569
    ],
    "arinta": [
        569
    ],
    "arranda": [
        569
    ],
    "arrinda": [
        569
    ],
    "arrundta": [
        569
    ],
    "arrunta": [
        569
    ],
    "arunda": [
        569
    ],
    "arunndta": [
        569
    ],
    "arunta bu": [
        569
    ],
    "arunta ulpma": [
        569
    ],
    "aragure": [
        571
    ],
    "aymara": [
        572,
        575
    ],
    "aimara": [
        572
    ],
    "aymar": [
        572,
        575
    ],
    "aymar aru": [
        572,
        575
    ],
    "aymara, central": [
        572
    ],
    "awar": [
        573
    ],
    "ayizo": [
        574
    ],
    "ayizo gbe": [
        574
    ],
    "ayizo-gbe": [
        574
    ],
    "ayzo": [
        574
    ],
    "aymara, southern": [
        575
    ],
    "ayabadhu": [
        576
    ],
    "abadja": [
        576
    ],
    "ai ebadu": [
        576
    ],
    "ai": [
        576,
        2063,
        4902,
        4903,
        4904,
        7236,
        3710,
        2123
    ],
    "aiabadu": [
        576
    ],
    "aiyabotho": [
        576
    ],
    "aiyaboto": [
        576
    ],
    "ajabadha": [
        576
    ],
    "ajabatha": [
        576
    ],
    "ajibyrdu": [
        576
    ],
    "apatya": [
        576
    ],
    "ayapathu": [
        576
    ],
    "ai-ebadu": [
        576
    ],
    "aiebadu": [
        576
    ],
    "ayere": [
        577
    ],
    "agnagan": [
        578
    ],
    "anyanga": [
        578
    ],
    "arabic, hadrami spoken": [
        579
    ],
    "asiga": [
        580
    ],
    "assiga": [
        580
    ],
    "ayiga": [
        580
    ],
    "ayigha": [
        580
    ],
    "akuku": [
        581
    ],
    "arabic, libyan spoken": [
        582
    ],
    "arabic, western egyptian bedawi spoken": [
        582
    ],
    "arabic, sanaani spoken": [
        583
    ],
    "ayoreo": [
        584
    ],
    "ayoeo": [
        584
    ],
    "ayoré": [
        584
    ],
    "ayoweo": [
        584
    ],
    "arabic, north mesopotamian spoken": [
        585
    ],
    "ayi": [
        586
    ],
    "ayi (papua new guinea)": [
        586
    ],
    "ayta, sorsogon": [
        587
    ],
    "ayta, magbukun": [
        588
    ],
    "ayu": [
        589
    ],
    "aya": [
        589
    ],
    "ajamaru": [
        591
    ],
    "atinjo": [
        591
    ],
    "ayamaru": [
        591
    ],
    "azerbaijani": [
        592,
        593,
        594,
        595,
        596,
        597,
        599,
        600,
        601
    ],
    "azərbaycan": [
        592,
        593,
        596,
        597
    ],
    "azerbaijan": [
        592,
        593,
        596,
        597,
        7706,
        594,
        600,
        601,
        695,
        3343,
        3701,
        3707,
        3948,
        4010,
        4012,
        4292,
        6631,
        7547,
        7584,
        7585,
        7586,
        7773,
        7775,
        7908
    ],
    "azerbaijani, north": [
        592,
        593,
        596,
        597
    ],
    "azerbaydzhani": [
        592,
        593,
        596,
        597
    ],
    "azeri": [
        592,
        593,
        596,
        597,
        599,
        600,
        601
    ],
    "azeri turk": [
        592,
        593,
        596,
        597
    ],
    "azərbaycan dili": [
        592,
        593,
        596,
        597
    ],
    "azərbaycanca": [
        592,
        593,
        596,
        597
    ],
    "az": [
        592,
        594,
        600,
        601,
        695,
        3343,
        3701,
        3707,
        3948,
        4010,
        4012,
        4292,
        6631,
        7547,
        7584,
        7585,
        7586,
        7773,
        7775,
        7908
    ],
    "azha": [
        598
    ],
    "ajiwa": [
        598
    ],
    "azan": [
        598
    ],
    "a’ndze": [
        598
    ],
    "a’ntsaozo": [
        598
    ],
    "azerbaijani, south": [
        599,
        600,
        601
    ],
    "azəricə": [
        599,
        600,
        601
    ],
    "aztec": [
        5453,
        602,
        605,
        608,
        5307,
        5343,
        5345,
        5356,
        5439,
        5447,
        5449,
        5451,
        5454,
        5456,
        5459,
        5461,
        5463,
        5464,
        5556
    ],
    "amuzgo, san pedro amuzgos": [
        603
    ],
    "amuzgos": [
        603
    ],
    "amuzgo bajo del este": [
        603,
        604
    ],
    "amuzgo de oaxaca": [
        603
    ],
    "amuzgo de san pedro amuzgos": [
        603
    ],
    "amuzgo, ipalapa": [
        604
    ],
    "agustin": [
        605
    ],
    "awing": [
        606
    ],
    "atembuluwe": [
        606
    ],
    "awi": [
        606
    ],
    "atta, faire": [
        607
    ],
    "arihini": [
        613,
        4784
    ],
    "an yüng": [
        624
    ],
    "an": [
        624,
        9184
    ],
    "abangba": [
        638
    ],
    "abaali": [
        672
    ],
    "awad bing": [
        680
    ],
    "awad": [
        680
    ],
    "awad gey": [
        680
    ],
    "abacama": [
        683
    ],
    "ako": [
        730
    ],
    "anak betawi": [
        736
    ],
    "anak": [
        736,
        4046
    ],
    "akuwagel": [
        739
    ],
    "as-so": [
        799
    ],
    "aisi jaisi got": [
        800
    ],
    "aisi": [
        4917,
        800
    ],
    "addo": [
        847
    ],
    "aga bereho": [
        861
    ],
    "ao biao": [
        862
    ],
    "ao": [
        5502,
        862,
        4824,
        936,
        1484,
        1836,
        3002,
        3029,
        3664,
        3695,
        3793,
        4097,
        4246,
        4420,
        4527,
        4635,
        4730,
        5211,
        5310,
        5373,
        5524,
        5595,
        5654,
        5707,
        5791,
        5797,
        5899,
        6226,
        6329,
        6966,
        7957,
        8448,
        8743
    ],
    "alante": [
        878,
        879,
        916
    ],
    "ambeno": [
        908
    ],
    "ambenu": [
        908
    ],
    "atinggola-bolango": [
        915
    ],
    "apadu vuolo": [
        917
    ],
    "apadu": [
        917
    ],
    "anii": [
        925
    ],
    "akpe": [
        925
    ],
    "angola": [
        936,
        1484,
        1836,
        3002,
        3029,
        3664,
        3695,
        3793,
        4097,
        4246,
        4420,
        4527,
        4635,
        4730,
        5211,
        5310,
        5373,
        5524,
        5595,
        5654,
        5707,
        5791,
        5797,
        5899,
        6226,
        6329,
        6966,
        7957,
        8448,
        8743
    ],
    "ayta, mag-indi": [
        938
    ],
    "ayta mag-indi": [
        938
    ],
    "antavaratra": [
        956
    ],
    "af-boon": [
        983
    ],
    "asi": [
        986,
        8181
    ],
    "asiq": [
        986
    ],
    "aweer": [
        1003
    ],
    "af aweera": [
        1003
    ],
    "aweera": [
        1003
    ],
    "anjam": [
        1009
    ],
    "am pìkkà": [
        1011
    ],
    "ampika": [
        1011
    ],
    "anika": [
        1011
    ],
    "afango": [
        1012
    ],
    "akuut": [
        1012
    ],
    "ambrym": [
        4907,
        7807,
        1600,
        1026
    ],
    "armopa": [
        1030
    ],
    "abwebwe": [
        1034
    ],
    "anasi": [
        1038
    ],
    "achab a maŋkɔ̧": [
        1069
    ],
    "achab": [
        1069
    ],
    "a": [
        4187,
        8525,
        8657,
        2346,
        3635,
        5028,
        1069,
        4955,
        7134
    ],
    "agere": [
        1071
    ],
    "agwe": [
        1071
    ],
    "abarambo": [
        1091
    ],
    "amiangba": [
        1091
    ],
    "amiangbwa": [
        1091
    ],
    "asha": [
        1099
    ],
    "abinomn": [
        1116
    ],
    "avinomen": [
        1116
    ],
    "ayan": [
        1118
    ],
    "asobse": [
        1123
    ],
    "akoose": [
        1135
    ],
    "akose": [
        1135
    ],
    "akosi": [
        1135
    ],
    "aradigi": [
        1155
    ],
    "ahtiago": [
        1168
    ],
    "atiahu": [
        1168
    ],
    "alas-kluet": [
        1169
    ],
    "alas-kluet batak": [
        1169
    ],
    "antalaotra": [
        1172
    ],
    "amampa": [
        1184
    ],
    "adeeyah": [
        1197
    ],
    "adija": [
        1197
    ],
    "anbarra": [
        1213
    ],
    "abane": [
        1216
    ],
    "avani": [
        1216
    ],
    "ayane": [
        1216
    ],
    "abin": [
        1280
    ],
    "agaw": [
        1284,
        1285
    ],
    "athpagari": [
        1293
    ],
    "andio": [
        1297
    ],
    "andio’o": [
        1297
    ],
    "antatsimo": [
        1298,
        4736
    ],
    "arandai": [
        3327,
        1312
    ],
    "abacha": [
        1319
    ],
    "abatsa": [
        1319
    ],
    "abanglekuo": [
        1321
    ],
    "abanliku": [
        1321
    ],
    "avand": [
        1322
    ],
    "avande": [
        1322
    ],
    "algherese catalan": [
        1323,
        1327
    ],
    "algherese": [
        1323,
        1327
    ],
    "ad": [
        2973,
        2974,
        2975,
        1324
    ],
    "andorra": [
        1324
    ],
    "ashlushlay": [
        1335
    ],
    "axluslay": [
        1335
    ],
    "axluxlay": [
        1335
    ],
    "auran": [
        1345
    ],
    "anenho": [
        1349
    ],
    "azora": [
        1362
    ],
    "aincacatai": [
        1364
    ],
    "asian swahili": [
        1378
    ],
    "asang": [
        1413
    ],
    "alphabet": [
        1421
    ],
    "aficen": [
        1422
    ],
    "asom": [
        1427
    ],
    "alto": [
        9135,
        6397,
        1440,
        1461,
        1528,
        1682,
        1716,
        5115,
        5220,
        6383,
        7716,
        7718
    ],
    "anumpa": [
        1451
    ],
    "aniyunwiya": [
        1455,
        1456
    ],
    "ayotzintepec": [
        1461
    ],
    "ayizo-ci": [
        1465
    ],
    "anishinaabemowin": [
        1475,
        1476,
        5865,
        5866
    ],
    "ashéninka, pajonal": [
        1489
    ],
    "ashéninka": [
        1489,
        1585,
        1592,
        1594,
        6297
    ],
    "asheninka": [
        1489,
        1585,
        1592,
        1594,
        6297
    ],
    "ashéninca": [
        1489,
        1586,
        1585,
        1592,
        6297
    ],
    "ashéninka pajonal": [
        1489
    ],
    "atsiri": [
        1489
    ],
    "aba": [
        1491,
        1492,
        8025
    ],
    "ashah": [
        1499
    ],
    "atsaʔ": [
        1499
    ],
    "anufo": [
        1504
    ],
    "awa khami": [
        1538
    ],
    "asháninka": [
        1546
    ],
    "ashinanca": [
        1546
    ],
    "asháninca": [
        1546
    ],
    "asmat, central": [
        1554
    ],
    "a'ingae": [
        1572
    ],
    "a’i": [
        1572
    ],
    "a’ingae": [
        1572
    ],
    "aguenquetsatsare": [
        1578
    ],
    "ashéninka, ucayali-yurúa": [
        1585
    ],
    "ajyíninka apurucayali": [
        1586
    ],
    "ajyíninka": [
        1586
    ],
    "apurucayali": [
        1586
    ],
    "ajyéninka": [
        1586
    ],
    "ashaninca": [
        1586
    ],
    "ashéninca apurucayali": [
        1586
    ],
    "asia minor greek": [
        1587
    ],
    "asia": [
        1587
    ],
    "ashéninka, pichis": [
        1592
    ],
    "ashéninka, south ucayali": [
        1594
    ],
    "ayimūn": [
        1609
    ],
    "absaroke": [
        1616
    ],
    "absarokee": [
        1616
    ],
    "apsaroke": [
        1616
    ],
    "apsáalooke": [
        1616
    ],
    "algonquian": [
        1618,
        6153
    ],
    "asho": [
        1636,
        1637
    ],
    "asho chin": [
        1636,
        1637
    ],
    "ahmyo": [
        1651
    ],
    "anhui": [
        1713,
        1714
    ],
    "af-dabarre": [
        1762
    ],
    "alemán": [
        1782,
        1785,
        1787,
        1791,
        1792,
        2572
    ],
    "alemão": [
        1782,
        1785,
        1787,
        1791,
        1792
    ],
    "allemand": [
        1782,
        1785,
        1787,
        1791,
        1792
    ],
    "athapascan": [
        1804,
        1805
    ],
    "acha’otinne": [
        1804,
        1805
    ],
    "agta, casiguran dumagat": [
        1815
    ],
    "agta casiguran": [
        1815
    ],
    "azaghvana": [
        1819
    ],
    "andaandi": [
        1822,
        1823,
        1824
    ],
    "andaˀaneti": [
        1828
    ],
    "alu": [
        8669,
        1845,
        5105
    ],
    "adzerma": [
        1872,
        1873,
        1874
    ],
    "adho-adhom": [
        1875
    ],
    "aukan": [
        1878,
        1879
    ],
    "aukaans": [
        1878,
        1879
    ],
    "adowen": [
        1881
    ],
    "adouma": [
        1896
    ],
    "aduma": [
        1896
    ],
    "af daasanach": [
        1970
    ],
    "adithinngithigh": [
        1983
    ],
    "adetingiti": [
        1983
    ],
    "ana": [
        1984,
        6446,
        3147,
        3148,
        8493,
        8973
    ],
    "ana tinga dogon": [
        1984
    ],
    "agta, umiray dumaget": [
        1998
    ],
    "abowe": [
        2004
    ],
    "amito": [
        2004
    ],
    "amowe": [
        2004
    ],
    "alabat": [
        2005
    ],
    "alabat island agta": [
        2005
    ],
    "alabat island dumagat": [
        2005
    ],
    "agta, dupaninan": [
        2008
    ],
    "agta, dicamay": [
        2017
    ],
    "agta, villa viciosa": [
        2034
    ],
    "aboo": [
        2054
    ],
    "ai hua": [
        2063
    ],
    "ancient": [
        8540,
        8556,
        8716,
        2070,
        2764,
        2765,
        2766,
        2914,
        8522,
        5824,
        7268
    ],
    "askopan": [
        2075
    ],
    "akajo": [
        2077,
        2078
    ],
    "akajuk": [
        2077,
        2078
    ],
    "akoti": [
        2085,
        2086
    ],
    "angoche": [
        2085,
        2086
    ],
    "angoje": [
        2085,
        2086
    ],
    "angoxe": [
        2085,
        2086
    ],
    "admiralitäts-inseln": [
        2100
    ],
    "aoma": [
        2102
    ],
    "atrato": [
        2109
    ],
    "alutiiq": [
        2111,
        2112
    ],
    "alaska": [
        3177,
        2111,
        2112
    ],
    "american english": [
        2118
    ],
    "anglais": [
        2118,
        2134,
        2135,
        2146,
        2210
    ],
    "angleščina": [
        2118,
        2134,
        2146,
        2210
    ],
    "anglisy": [
        2118,
        2134,
        2146,
        2210
    ],
    "angličtina": [
        2118,
        2134,
        2146,
        2210
    ],
    "anglų": [
        2118,
        2134,
        2146,
        2210
    ],
    "angol": [
        2118,
        2134,
        2146,
        2210
    ],
    "angļu": [
        2118,
        2134,
        2146,
        2210
    ],
    "angielski": [
        2118,
        2134,
        2146,
        2210
    ],
    "anguilla": [
        2123
    ],
    "american samoa": [
        2124
    ],
    "australian english": [
        2126
    ],
    "ascension": [
        2204
    ],
    "apal": [
        2227
    ],
    "apali": [
        2227
    ],
    "apalɨ": [
        2227
    ],
    "ainh": [
        2229
    ],
    "ambuvilluvedar": [
        2246
    ],
    "arokwa": [
        2248
    ],
    "aheri": [
        2287,
        2288,
        2289
    ],
    "aheri gondi": [
        2287,
        2288,
        2289
    ],
    "alaskan": [
        2291,
        2299
    ],
    "al-ishaara": [
        2292
    ],
    "al-masriya": [
        2292
    ],
    "al-‘ishāra": [
        2292
    ],
    "al-maṣriyya": [
        2292
    ],
    "asiatic yupik": [
        2297,
        2298
    ],
    "asiatic": [
        2297,
        2298
    ],
    "ado": [
        2309
    ],
    "afenmai": [
        2310
    ],
    "aten": [
        2314
    ],
    "avanki": [
        2320,
        2321,
        2322
    ],
    "avankil": [
        2320,
        2321,
        2322
    ],
    "ajamic": [
        2329
    ],
    "aporo": [
        2331
    ],
    "annobonense": [
        2332
    ],
    "annobonese": [
        2332
    ],
    "annobonés": [
        2332
    ],
    "a fala de xálima": [
        2346
    ],
    "a fala do xãlima": [
        2346
    ],
    "albay": [
        2349
    ],
    "afiran": [
        2390
    ],
    "abawiri": [
        2397
    ],
    "acadian": [
        2466
    ],
    "arpitan": [
        2471
    ],
    "arpetan": [
        2471
    ],
    "arpitano": [
        2471
    ],
    "adamawa": [
        2479,
        2480
    ],
    "adamawa fulani": [
        2479,
        2480
    ],
    "adamawa fulfulde": [
        2479,
        2480
    ],
    "accra": [
        2507,
        2508
    ],
    "acra": [
        2507,
        2508
    ],
    "amina": [
        2507,
        2508
    ],
    "andamanese": [
        2510
    ],
    "andamese": [
        2510
    ],
    "arequena": [
        2512
    ],
    "alekano": [
        2517
    ],
    "asa": [
        2528
    ],
    "adiwasi": [
        2530,
        5959,
        8059,
        8060
    ],
    "adiwasi garasia": [
        2530
    ],
    "adiwasi girasia": [
        2530
    ],
    "adiwasi gujarati": [
        2530
    ],
    "aziana": [
        2531
    ],
    "afaani borana": [
        2534,
        2535
    ],
    "afaani": [
        2534,
        2535
    ],
    "abdedal": [
        2559
    ],
    "abiddul": [
        2559
    ],
    "alemán coloniero": [
        2572
    ],
    "albannach": [
        2573
    ],
    "afkabiye": [
        2580
    ],
    "af-garre": [
        2612
    ],
    "ayo": [
        2654,
        8733,
        8734
    ],
    "akpese": [
        2672
    ],
    "anej": [
        2687
    ],
    "avanye’e": [
        2703
    ],
    "avañee": [
        2703
    ],
    "avañe’ẽ": [
        2703
    ],
    "arauca": [
        2724
    ],
    "aqao": [
        2760
    ],
    "aqaw": [
        2760
    ],
    "ancient greek (to 1453)": [
        2764,
        2765,
        2766
    ],
    "alemanic": [
        2795
    ],
    "alemannic": [
        2797,
        2795,
        2796
    ],
    "alemannisch": [
        2795,
        2796,
        2797
    ],
    "alsacien": [
        2795,
        2796
    ],
    "alsatian": [
        2796,
        2795,
        2797
    ],
    "aghu-tharnggala": [
        2799
    ],
    "aghu tharnggala": [
        2799
    ],
    "aghu tharnggalai": [
        2799
    ],
    "aghu tharnggalu": [
        2799,
        3184
    ],
    "aché": [
        2818
    ],
    "ache-guayaki": [
        2818
    ],
    "aché-guayaki": [
        2818
    ],
    "axé": [
        2818
    ],
    "anana": [
        2828
    ],
    "awá": [
        2831
    ],
    "awá guajá": [
        2831
    ],
    "ayaya": [
        2831
    ],
    "ale": [
        2844,
        5319
    ],
    "awngthim": [
        2850
    ],
    "angudimi": [
        2850
    ],
    "arandui": [
        2853
    ],
    "anum-boso": [
        2856
    ],
    "ate": [
        2858
    ],
    "agyem": [
        2860
    ],
    "abakwariga": [
        2874,
        2875,
        2876
    ],
    "avromani": [
        2884
    ],
    "awroman": [
        2884
    ],
    "awromani": [
        2884
    ],
    "atam": [
        2885
    ],
    "azargi": [
        2910
    ],
    "abul": [
        2913
    ],
    "ancient hebrew": [
        2914
    ],
    "andaman hindi creole": [
        2916
    ],
    "andaman": [
        2916
    ],
    "andaman creole hindi": [
        2916
    ],
    "andaman hindi": [
        2916
    ],
    "amasili": [
        2950
    ],
    "aia jaia got": [
        2965
    ],
    "aia": [
        2965
    ],
    "a-hmao": [
        2973,
        2974,
        2975
    ],
    "a-hmaos": [
        2973,
        2974,
        2975
    ],
    "ad hmaob lul": [
        2973,
        2974,
        2975
    ],
    "aili gaili": [
        3013
    ],
    "aili": [
        3013
    ],
    "a-hmo": [
        3050
    ],
    "aroi": [
        3051
    ],
    "angka": [
        3054
    ],
    "angkae": [
        3054
    ],
    "anir": [
        3055
    ],
    "ayisyen": [
        3064
    ],
    "alakamat": [
        3074
    ],
    "asli": [
        3074
    ],
    "angku": [
        3084
    ],
    "akhni": [
        3094
    ],
    "aveke": [
        3098
    ],
    "armani": [
        3104,
        3105,
        6627,
        6628
    ],
    "armjanski": [
        3104,
        3105
    ],
    "armjanski yazyk": [
        3104,
        3105
    ],
    "armenian, western": [
        3107
    ],
    "auxiliary": [
        3109,
        3110
    ],
    "akpes": [
        3118
    ],
    "agoi": [
        3122
    ],
    "andrés": [
        3130,
        5992,
        7718
    ],
    "ajiya": [
        3136
    ],
    "ajuli": [
        3136
    ],
    "amganad": [
        3145
    ],
    "amganad ifugao": [
        3145
    ],
    "ayangan ifugao": [
        3146
    ],
    "ayangan": [
        3146
    ],
    "ana-ife": [
        3147,
        3148
    ],
    "ana-ifé": [
        3147
    ],
    "anago": [
        3147,
        3148
    ],
    "antipolo ifugao": [
        3153
    ],
    "antipolo": [
        3153
    ],
    "asụsụ igbo": [
        3154
    ],
    "asụsụ": [
        3154
    ],
    "amegi": [
        3173
    ],
    "ankulu": [
        3181
    ],
    "ape": [
        3192
    ],
    "anamuxra": [
        3206
    ],
    "anamgura": [
        3206
    ],
    "akenóiri": [
        3233
    ],
    "amacacore": [
        3233
    ],
    "arguni bay": [
        3236
    ],
    "aregwe": [
        3237
    ],
    "apayao": [
        3248
    ],
    "aisl": [
        3250
    ],
    "australian irish sign language": [
        3250
    ],
    "awain": [
        3251
    ],
    "alowiemino": [
        3273
    ],
    "afizare": [
        3300
    ],
    "afizarek": [
        3300
    ],
    "afizere": [
        3300
    ],
    "afudelek": [
        3300
    ],
    "afusare": [
        3300
    ],
    "abxubal": [
        3307
    ],
    "abꞌxubꞌal poptiꞌ": [
        3307
    ],
    "abꞌxubꞌal": [
        3307
    ],
    "atamanu": [
        3314
    ],
    "awaiya": [
        3314
    ],
    "aniula": [
        3317
    ],
    "anula": [
        3317
    ],
    "anyula": [
        3317
    ],
    "af-jiiddu": [
        3369
    ],
    "aka koro": [
        3384
    ],
    "amami koniya sign language": [
        3385
    ],
    "amami": [
        3385
    ],
    "amami-oshima shuwa": [
        3385
    ],
    "angire": [
        3387
    ],
    "arra": [
        3387
    ],
    "ajanji": [
        3403
    ],
    "anafejanzi": [
        3403
    ],
    "al-ishāra": [
        3414
    ],
    "al-urdunia": [
        3414
    ],
    "ak’aro": [
        3418
    ],
    "atak": [
        3422
    ],
    "abinsi": [
        3427
    ],
    "awannu": [
        3427
    ],
    "aluri": [
        3431,
        8957
    ],
    "alury": [
        3431,
        8957
    ],
    "arabic, judeo-yemeni": [
        3450
    ],
    "amazigh": [
        3458,
        3459,
        3460,
        7491,
        7492,
        7594,
        7595,
        7596,
        7884,
        7885,
        7886
    ],
    "aphu": [
        3461,
        8753
    ],
    "adara": [
        3462
    ],
    "ahin-kayapa kalanguya": [
        3469
    ],
    "ahin-kayapa": [
        3469
    ],
    "akamba": [
        3470
    ],
    "awe": [
        3500
    ],
    "ap ma": [
        3502
    ],
    "ap": [
        3502
    ],
    "ap ma botin": [
        3502
    ],
    "aika (ayanran-ishe-kakumo-auga)": [
        3511
    ],
    "aika": [
        3511
    ],
    "ayanran-ishe-kakumo-auga": [
        3511
    ],
    "anyaran": [
        3511
    ],
    "angan": [
        3514
    ],
    "apoze": [
        3517
    ],
    "akalak": [
        3523
    ],
    "akokolemu": [
        3540
    ],
    "akarimojong": [
        3541
    ],
    "a-karamojoŋ": [
        3541
    ],
    "a-karimojoŋ": [
        3541
    ],
    "akimba": [
        3543
    ],
    "auna": [
        3543
    ],
    "agoma": [
        3544
    ],
    "achikunda": [
        3545
    ],
    "aouei": [
        3550,
        3551,
        3552
    ],
    "akele": [
        3559
    ],
    "akebu": [
        3578
    ],
    "akebou": [
        3578
    ],
    "akébou": [
        3578
    ],
    "adaa agaa": [
        3581
    ],
    "adaa": [
        3581,
        3721
    ],
    "agaa": [
        3581
    ],
    "adaa agale": [
        3721,
        3581
    ],
    "agale": [
        3721,
        3581
    ],
    "anuskad": [
        3601,
        3602
    ],
    "amapá": [
        3630
    ],
    "abun": [
        3635
    ],
    "a nden": [
        3635
    ],
    "atl’ilqo": [
        3665
    ],
    "arniya": [
        3666
    ],
    "abri": [
        3672
    ],
    "agob": [
        3687
    ],
    "alevica": [
        3688
    ],
    "alevija": [
        3688
    ],
    "aoshedd": [
        3691
    ],
    "abakan tatar": [
        3705
    ],
    "abakan": [
        3705,
        3884
    ],
    "acoma-laguna": [
        3719
    ],
    "adyaktye": [
        3735
    ],
    "akanda": [
        3735
    ],
    "anu": [
        3738,
        5737
    ],
    "akayon": [
        3749
    ],
    "akoiyang": [
        3749
    ],
    "aforo": [
        3800
    ],
    "awtuw": [
        3806
    ],
    "autu": [
        3806
    ],
    "anib": [
        3826
    ],
    "aninib": [
        3826
    ],
    "akateko": [
        3827
    ],
    "acatec": [
        3827
    ],
    "acateco": [
        3827
    ],
    "acatán": [
        3827
    ],
    "amchigela": [
        3832,
        3833,
        3861
    ],
    "acre": [
        4628,
        3840,
        8597
    ],
    "amako": [
        3872
    ],
    "akposo": [
        3888
    ],
    "akposso": [
        3888
    ],
    "aikoli": [
        3893
    ],
    "alngubin": [
        3899
    ],
    "aimorés": [
        3914
    ],
    "akarore": [
        3931
    ],
    "akurmi": [
        3933
    ],
    "akurumi": [
        3933
    ],
    "azumu": [
        3933
    ],
    "antiqueño": [
        3935
    ],
    "ansudu": [
        4016
    ],
    "apalakiri": [
        4022
    ],
    "apalaquiri": [
        4022
    ],
    "akande": [
        4025
    ],
    "akandi": [
        4025
    ],
    "ah’e": [
        4032
    ],
    "atacameño": [
        4040
    ],
    "antai": [
        4040
    ],
    "anak dalam": [
        4046
    ],
    "air mati": [
        4077
    ],
    "air": [
        4077
    ],
    "airmati": [
        4077
    ],
    "armati": [
        4077
    ],
    "aiduma": [
        4080
    ],
    "awa-cuaiquer": [
        4081
    ],
    "awapit": [
        4081
    ],
    "awa pit": [
        4081
    ],
    "auapit": [
        4081
    ],
    "abakoum": [
        4092
    ],
    "abakum": [
        4092
    ],
    "akpwakum": [
        4092
    ],
    "amniapé": [
        4114
    ],
    "asa’a": [
        4160
    ],
    "apo duat": [
        4169
    ],
    "apo": [
        4169
    ],
    "aiso": [
        4172
    ],
    "atori": [
        4172
    ],
    "aribwatsa": [
        4216
    ],
    "adong": [
        4253
    ],
    "adṹ": [
        4253
    ],
    "anyima": [
        4255
    ],
    "anemoro": [
        4258
    ],
    "anowuru": [
        4258
    ],
    "amio-gelimi": [
        4285
    ],
    "amio": [
        4285
    ],
    "atui": [
        4285
    ],
    "aku": [
        4352
    ],
    "api": [
        4353,
        4354
    ],
    "arwur-angkana": [
        4356
    ],
    "alaki": [
        4363
    ],
    "agomes": [
        4379
    ],
    "acaxee": [
        4383
    ],
    "akiuru": [
        4399
    ],
    "akivru": [
        4399
    ],
    "anguru": [
        4453
    ],
    "amimi naga": [
        4470
    ],
    "amimi": [
        4470
    ],
    "al-leira": [
        4484
    ],
    "acye": [
        4495
    ],
    "ac’ye": [
        4495
    ],
    "aruop": [
        4501
    ],
    "acholi-labwor": [
        4511
    ],
    "aringa": [
        4519
    ],
    "aringa ti": [
        4519
    ],
    "aluyi": [
        4563
    ],
    "antonio": [
        4571,
        5223,
        8652
    ],
    "apabhramsa": [
        4577,
        4578,
        4579,
        4580
    ],
    "andira": [
        4595
    ],
    "arapium": [
        4595
    ],
    "anodöb": [
        4608
    ],
    "agualinda guahibo": [
        4612
    ],
    "agualinda": [
        4612
    ],
    "arosario": [
        4614
    ],
    "arsario": [
        4614
    ],
    "amoltepec": [
        4624
    ],
    "amoltepec mixtec": [
        4624
    ],
    "acre arara": [
        4628
    ],
    "arara shawãdawa": [
        4628
    ],
    "arara do acre": [
        4628
    ],
    "ayuk": [
        4639,
        5115,
        5221,
        4810
    ],
    "aulad djema": [
        4655,
        4656
    ],
    "aulad": [
        4655,
        4656
    ],
    "awlad djema": [
        4655,
        4656
    ],
    "awlad": [
        4655,
        4656
    ],
    "amangbetu": [
        4661
    ],
    "andian": [
        4668,
        4669
    ],
    "ambede": [
        4671
    ],
    "aikewara": [
        4679
    ],
    "akewara": [
        4679
    ],
    "akewere": [
        4679
    ],
    "arfak": [
        4688
    ],
    "arabic, hasanya": [
        4704,
        4705
    ],
    "arabic, hassaniyya": [
        4704,
        4705
    ],
    "abɔŋnamɛnda": [
        4711
    ],
    "ambuela": [
        4730
    ],
    "ambuella": [
        4730
    ],
    "ambaniandro": [
        4736,
        4738
    ],
    "abiri": [
        4740
    ],
    "abiyi": [
        4740
    ],
    "abureni": [
        4749
    ],
    "ajokoot": [
        4773
    ],
    "austronesian mor": [
        4789
    ],
    "austronesian": [
        4789
    ],
    "atatlahuca": [
        4792
    ],
    "atatláhuca mixtec": [
        4792
    ],
    "atatláhuca": [
        4792
    ],
    "aŋgwa": [
        4797
    ],
    "abar": [
        4801
    ],
    "alacatlatzala": [
        4804
    ],
    "alacatlatzala mixtec": [
        4804
    ],
    "apasco-apoala": [
        4808
    ],
    "apasco mixtec": [
        4808
    ],
    "apasco": [
        4808
    ],
    "apasco-apoala mixtec": [
        4808
    ],
    "apoala mixtec": [
        4808
    ],
    "apoala": [
        4808
    ],
    "acatlán mixtec": [
        4812
    ],
    "acatlán": [
        4812
    ],
    "akoye": [
        4814
    ],
    "akoinkake": [
        4814
    ],
    "akoyi": [
        4814
    ],
    "angoya": [
        4814
    ],
    "ayutla": [
        4816
    ],
    "ayutla mixtec": [
        4816
    ],
    "arayans": [
        4833
    ],
    "arayan": [
        4833
    ],
    "arleng alam": [
        4840
    ],
    "arleng": [
        4840
    ],
    "alam": [
        6091,
        4840
    ],
    "alealum": [
        4872,
        4873,
        4874
    ],
    "ai nan": [
        4902,
        4903,
        4904
    ],
    "ambrym, north": [
        4907
    ],
    "amben": [
        4909
    ],
    "aregerek": [
        4909
    ],
    "amono": [
        4942
    ],
    "aleng": [
        4956
    ],
    "aimun": [
        4963,
        5690,
        5691
    ],
    "aionun": [
        4963
    ],
    "azumeina": [
        4990
    ],
    "a mŏk": [
        5028
    ],
    "a’ara": [
        5053
    ],
    "amadi": [
        5082
    ],
    "agusan": [
        5085
    ],
    "agusan manobo": [
        5085
    ],
    "aruamu": [
        5096
    ],
    "ariawiai": [
        5096
    ],
    "anyin morofo": [
        5102
    ],
    "asaro’o": [
        5122
    ],
    "asaro'o": [
        5122
    ],
    "asarɨ’o": [
        5122
    ],
    "ajumbu": [
        5128
    ],
    "ajuh mbuh": [
        5128
    ],
    "ajuh": [
        5128
    ],
    "adzu": [
        5128
    ],
    "aleut, mednyj": [
        5129
    ],
    "attuan": [
        5129
    ],
    "adkibba": [
        5140,
        5141
    ],
    "agiba": [
        5140,
        5141
    ],
    "ajibba": [
        5140,
        5141
    ],
    "ambara": [
        5161
    ],
    "are": [
        5177
    ],
    "aiklep": [
        5180
    ],
    "agerlep": [
        5180
    ],
    "aria-mouk": [
        5181
    ],
    "arm": [
        5197,
        5198,
        5199,
        5200,
        5201
    ],
    "aasʼè": [
        5236
    ],
    "anta": [
        5237
    ],
    "anfillo": [
        5245
    ],
    "aga-muyuw": [
        5251
    ],
    "ayuuk": [
        5267,
        5403
    ],
    "aikoa": [
        5272
    ],
    "aculo": [
        5278
    ],
    "anaguta": [
        5301
    ],
    "aunge": [
        5302
    ],
    "angami": [
        5500,
        5317,
        5669
    ],
    "airiman": [
        5318
    ],
    "arak": [
        5325
    ],
    "arufe": [
        5346
    ],
    "andasa": [
        5359
    ],
    "arunamese": [
        5394
    ],
    "ahwai": [
        5416
    ],
    "ayiwo": [
        5417
    ],
    "aïwo": [
        5417
    ],
    "angie": [
        5429
    ],
    "acilowe": [
        5431
    ],
    "alomwe": [
        5431
    ],
    "ava": [
        5448,
        8146
    ],
    "apytare": [
        5448
    ],
    "ava guaraní": [
        5448
    ],
    "ava-chiripá": [
        5448
    ],
    "ava-katu-ete": [
        5448
    ],
    "ahuacatlán and tepetzintla": [
        5453
    ],
    "ahuacatlán": [
        5453
    ],
    "aztec of zacatlán": [
        5453
    ],
    "almomoloa náhuatl": [
        5463
    ],
    "almomoloa": [
        5463
    ],
    "aztec-mecayapan": [
        5465
    ],
    "akiza": [
        5480
    ],
    "amar tita": [
        5480
    ],
    "amar": [
        5480
    ],
    "ancha": [
        5480
    ],
    "angami naga": [
        5500
    ],
    "angamis": [
        5500
    ],
    "ao naga": [
        5502
    ],
    "aorr": [
        5502
    ],
    "asmat, north": [
        5529
    ],
    "aw": [
        5537,
        6033
    ],
    "aruba": [
        5537,
        6033
    ],
    "alngam": [
        5557
    ],
    "ambae, west": [
        5594
    ],
    "ambae": [
        5594,
        5905
    ],
    "atiri": [
        5635
    ],
    "assiringia": [
        5644
    ],
    "akyaung": [
        5660
    ],
    "akyaung ari naga": [
        5660
    ],
    "angom": [
        5663
    ],
    "ala’ala": [
        5680
    ],
    "aht": [
        5734
    ],
    "anong": [
        5737
    ],
    "anoong": [
        5737
    ],
    "anung": [
        5737
    ],
    "agiryama": [
        5792
    ],
    "ama (sudan)": [
        5795
    ],
    "anaiwan": [
        5810
    ],
    "aniwan": [
        5810
    ],
    "akonto": [
        5812
    ],
    "akwanto": [
        5812
    ],
    "appolo": [
        5815
    ],
    "ansakara": [
        5816
    ],
    "arung": [
        5817
    ],
    "ancient aramaic (up to 700 bce)": [
        5824
    ],
    "abuloma": [
        5833
    ],
    "aranese": [
        5834
    ],
    "aranés": [
        5834
    ],
    "aranés occitán": [
        5834
    ],
    "arnais": [
        5834
    ],
    "atzingo": [
        5839,
        6251
    ],
    "atzingo matlatzinca": [
        5839
    ],
    "atzinteco": [
        5839
    ],
    "agbaragba": [
        5847
    ],
    "anishnaubemowin": [
        5868,
        5869
    ],
    "akita": [
        5874
    ],
    "akiek": [
        5878
    ],
    "aunus": [
        5896
    ],
    "ambae, east": [
        5905
    ],
    "aoba": [
        5905
    ],
    "agua": [
        5907
    ],
    "anapia": [
        5907
    ],
    "ariana": [
        5907
    ],
    "aona": [
        5920
    ],
    "adivasi": [
        5959
    ],
    "adivasi oriya": [
        5959
    ],
    "adiwasi oriya": [
        5959
    ],
    "arití": [
        6016
    ],
    "apagibete": [
        6021
    ],
    "apagibeti": [
        6021
    ],
    "apakabeti": [
        6021
    ],
    "apakibeti": [
        6021
    ],
    "apiterewa": [
        6027
    ],
    "amánung sísuan": [
        6030,
        6031
    ],
    "amánung": [
        6030,
        6031
    ],
    "afghana-yi nasfurush": [
        6034
    ],
    "afghana-yi": [
        6034
    ],
    "afghana-yi siyarui": [
        6034
    ],
    "anun": [
        6905,
        6047
    ],
    "añú": [
        6047
    ],
    "abira": [
        6048
    ],
    "acapulco": [
        6056
    ],
    "ahuatempan": [
        6060
    ],
    "anglo-nigerian pidgin": [
        6077
    ],
    "anglo-nigerian": [
        6077
    ],
    "abishi": [
        6078
    ],
    "abisi": [
        6078
    ],
    "anam": [
        6081
    ],
    "alalao": [
        6085
    ],
    "andje": [
        6092
    ],
    "arabi juba": [
        6111
    ],
    "apindje": [
        6144
    ],
    "apindji": [
        6144
    ],
    "apindzi": [
        6144
    ],
    "apinji": [
        6144
    ],
    "adole": [
        6145
    ],
    "amorua": [
        6145
    ],
    "ature": [
        6145
    ],
    "algonkian": [
        6153
    ],
    "amarizado": [
        6155
    ],
    "ambandi": [
        6164
    ],
    "ardhamāgadhī prākrit": [
        6167
    ],
    "ardhamāgadhī": [
        6167
    ],
    "attapady": [
        6176
    ],
    "attapady kurumba": [
        6176
    ],
    "aukuyene": [
        6198
    ],
    "aukwayene": [
        6198
    ],
    "apambia": [
        6204
    ],
    "aljamia": [
        6212
    ],
    "arringeu": [
        6228
    ],
    "aoheng": [
        6230
    ],
    "aramo": [
        6235
    ],
    "atzingo popoloca": [
        6251
    ],
    "afro-portugais": [
        6264
    ],
    "akwa’ala": [
        6269
    ],
    "akium-pare": [
        6278
    ],
    "afa": [
        6280
    ],
    "afanci": [
        6280
    ],
    "afawa": [
        6280
    ],
    "ashéninka, perené": [
        6297
    ],
    "ashéninka perené": [
        6297
    ],
    "afghan persian": [
        6299
    ],
    "awyu, asue": [
        6308
    ],
    "asue": [
        6308
    ],
    "asue awyu": [
        6308
    ],
    "aput": [
        6357
    ],
    "aurã": [
        6368
    ],
    "aurama": [
        6374
    ],
    "alkansea": [
        6396
    ],
    "arkansas": [
        6396
    ],
    "alto huallaga": [
        6397
    ],
    "amazonas quechua": [
        6403
    ],
    "ayacucho": [
        6414
    ],
    "ayacucho quechua": [
        6414
    ],
    "ambo-pasco": [
        6415
    ],
    "ambo-pasco quechua": [
        6415
    ],
    "apurímac": [
        6417
    ],
    "apurímac quechua": [
        6417
    ],
    "azuay quichua": [
        6420
    ],
    "azuay": [
        6420
    ],
    "alama": [
        6429,
        7879
    ],
    "ancash": [
        6430,
        6432,
        6434,
        6440,
        6436,
        6441
    ],
    "anqas qichwa": [
        6432
    ],
    "anqas": [
        6432
    ],
    "ancash quechua": [
        6436
    ],
    "arequipa-la": [
        6447
    ],
    "arequipa quechua": [
        6447
    ],
    "arequipa": [
        6447
    ],
    "arequipa-la unión quechua": [
        6447
    ],
    "arthare-khesang": [
        6454
    ],
    "annaberg": [
        6469
    ],
    "airani": [
        6472
    ],
    "afi renꞌdille": [
        6499
    ],
    "afi": [
        6499
    ],
    "arrif": [
        6519,
        6520,
        6521,
        6522
    ],
    "aripaktsá": [
        6533
    ],
    "arakanese": [
        6535
    ],
    "anchalit bangla": [
        6537
    ],
    "anchalit": [
        6537
    ],
    "arakwal": [
        6538
    ],
    "angloromani": [
        6544
    ],
    "anglo-romani": [
        6544
    ],
    "armenian bosa": [
        6548
    ],
    "armenian bosha": [
        6548
    ],
    "arnebuab bisa": [
        6548
    ],
    "arnebuab": [
        6548
    ],
    "aic": [
        6557
    ],
    "ai’": [
        6557
    ],
    "a’e": [
        6557
    ],
    "arkanese-marma": [
        6565
    ],
    "adlai": [
        6586
    ],
    "asiagao reo": [
        6591
    ],
    "asiagao": [
        6591
    ],
    "aiki": [
        6594
    ],
    "ayki": [
        6594
    ],
    "aykindang": [
        6594
    ],
    "arritinngithigh": [
        6600
    ],
    "aromanian": [
        6627,
        6628
    ],
    "armina": [
        6627,
        6628
    ],
    "armini": [
        6627,
        6628
    ],
    "aromunian": [
        6627,
        6628
    ],
    "arumanian": [
        6627,
        6628
    ],
    "arumanisht": [
        6627,
        6628
    ],
    "arumenian": [
        6627,
        6628
    ],
    "arumun": [
        6627,
        6628
    ],
    "amala": [
        6633
    ],
    "amba": [
        6640,
        8025
    ],
    "amba (uganda)": [
        6640
    ],
    "amami-oshima, northern": [
        6646
    ],
    "asake": [
        6667
    ],
    "aejauroh": [
        6684
    ],
    "aeta negrito": [
        6702
    ],
    "aeta": [
        6702
    ],
    "ayta hambali": [
        6702
    ],
    "aipki": [
        6710
    ],
    "agbane": [
        6755
    ],
    "agbanekundi": [
        6755
    ],
    "akbana": [
        6755
    ],
    "asaba": [
        6788
    ],
    "akiapmin": [
        6788
    ],
    "asabano": [
        6788
    ],
    "arui": [
        6794
    ],
    "aido pãi": [
        6797
    ],
    "aido": [
        6797
    ],
    "atse": [
        6801
    ],
    "asahyue": [
        6803
    ],
    "ayta, mag-antsi": [
        6807
    ],
    "ayta mag-antsi": [
        6807
    ],
    "anchi": [
        6807
    ],
    "antsi": [
        6807
    ],
    "apeen bol": [
        6833
    ],
    "apeen": [
        6833
    ],
    "arabic, chadian spoken": [
        6855,
        6856
    ],
    "arabe choa": [
        6855,
        6856
    ],
    "arabe": [
        6855,
        6856
    ],
    "arabic, shuwa": [
        6855,
        6856
    ],
    "arabi hana tchad": [
        6856
    ],
    "aurès": [
        6860,
        6861,
        6862
    ],
    "awras": [
        6860,
        6861,
        6862
    ],
    "akkala": [
        6866
    ],
    "ahkkil": [
        6866
    ],
    "akkala sami": [
        6866
    ],
    "afoo": [
        6868
    ],
    "arjeplog saami": [
        6892
    ],
    "arjeplog": [
        6892
    ],
    "assangori": [
        6893
    ],
    "asong": [
        6893,
        6956
    ],
    "assoungor": [
        6893
    ],
    "asungore": [
        6893
    ],
    "azanguri": [
        6893
    ],
    "auwe": [
        6967
    ],
    "asimbali": [
        6968
    ],
    "anarâškielâ": [
        6974
    ],
    "anar": [
        6974
    ],
    "aswanek": [
        7000,
        7001
    ],
    "aswanik": [
        7000,
        7001
    ],
    "azer": [
        7000,
        7001
    ],
    "asas": [
        7016
    ],
    "af-maxaad tiri": [
        7017,
        7018,
        7022
    ],
    "af-maxaad": [
        7017,
        7018,
        7022
    ],
    "af-soomaali": [
        7017,
        7018,
        7022
    ],
    "afka soomaaliga": [
        7017,
        7018,
        7022
    ],
    "afka": [
        7017,
        7018,
        7022
    ],
    "akukem": [
        7057
    ],
    "akɨghɨm": [
        7057
    ],
    "albanian, tosk": [
        7068,
        7070,
        7071
    ],
    "arnaut": [
        7068,
        7070,
        7071
    ],
    "albanian sign language": [
        7077
    ],
    "albsl": [
        7077
    ],
    "arabic, shihhi spoken": [
        7136
    ],
    "al-shihuh": [
        7136
    ],
    "ariangulu": [
        7142
    ],
    "asengseng": [
        7155
    ],
    "aramba": [
        7168
    ],
    "arammba": [
        7168
    ],
    "anna": [
        7171
    ],
    "ax": [
        7210
    ],
    "ainiayn": [
        7216
    ],
    "arab-swahili": [
        7223,
        7234,
        7235
    ],
    "ai sui": [
        7236
    ],
    "abasuba": [
        7253
    ],
    "aluwa": [
        7262
    ],
    "ancient syriac": [
        7268
    ],
    "atiga": [
        7268
    ],
    "adikimmu sukur": [
        7270
    ],
    "adikimmu": [
        7270
    ],
    "al-sayyid bedouin sign language": [
        7281
    ],
    "al-sayyid": [
        7281
    ],
    "absl": [
        7281
    ],
    "athabaskan": [
        7301
    ],
    "apyãwa": [
        7306
    ],
    "alta tarahumara": [
        7318
    ],
    "annamite french": [
        7319
    ],
    "annamite": [
        7319
    ],
    "atayal": [
        7324,
        7325,
        7326
    ],
    "ataiyal": [
        7324,
        7325,
        7326
    ],
    "attayal": [
        7324,
        7325,
        7326
    ],
    "aikanã": [
        7328
    ],
    "aikaná": [
        7328
    ],
    "aborlan tagbanwa": [
        7350,
        7351
    ],
    "aborlan": [
        7350,
        7351
    ],
    "apurawnon": [
        7350,
        7351
    ],
    "ailan tok": [
        7371
    ],
    "ailan": [
        7371
    ],
    "ap-ne-ap": [
        7371
    ],
    "adjio": [
        7394
    ],
    "ansur": [
        7396
    ],
    "aroaqui": [
        7397
    ],
    "antandroy": [
        7405
    ],
    "andhra": [
        7407,
        7408,
        8247
    ],
    "alima": [
        7415
    ],
    "aonek’enk": [
        7416
    ],
    "aoniken": [
        7416
    ],
    "anamagi": [
        7417
    ],
    "ateso": [
        7421,
        7422
    ],
    "atεsᴐ": [
        7421,
        7422
    ],
    "arisiachi tarahumara": [
        7473
    ],
    "arisiachi": [
        7473
    ],
    "atharaka": [
        7475
    ],
    "aheu": [
        7477
    ],
    "adasen": [
        7514
    ],
    "addasen": [
        7514
    ],
    "addasen tinguian": [
        7514
    ],
    "antaisaka": [
        7541
    ],
    "antesaka": [
        7541
    ],
    "atesaka": [
        7541
    ],
    "ajomang": [
        7575
    ],
    "aw-aak": [
        7577
    ],
    "amana": [
        7581
    ],
    "avava": [
        7588
    ],
    "azbinawa": [
        7594,
        7595,
        7596
    ],
    "asmat darat": [
        7600,
        7856
    ],
    "aguas blancas": [
        7616
    ],
    "aguas": [
        7616
    ],
    "angosturas": [
        7618
    ],
    "angosturas tunebo": [
        7618
    ],
    "apapantilla totonac": [
        7649
    ],
    "apapantilla": [
        7649
    ],
    "akara": [
        7651
    ],
    "azoyú": [
        7661
    ],
    "azoyú me'phaa": [
        7661
    ],
    "azoyú tlapanec": [
        7661
    ],
    "acatepec": [
        7680
    ],
    "acatepec me'phaa": [
        7680
    ],
    "acatepec tlapanec": [
        7680
    ],
    "af-tunni": [
        7689
    ],
    "anatolian": [
        7694,
        7695,
        7696,
        7699
    ],
    "akei": [
        7744
    ],
    "aikwakai": [
        7779
    ],
    "araikurioko": [
        7779
    ],
    "avadi": [
        7805
    ],
    "ambrym, southeast": [
        7807
    ],
    "awu laya": [
        7869
    ],
    "awu": [
        8810,
        7869
    ],
    "awu-alaya": [
        7869
    ],
    "ayaa": [
        7877
    ],
    "atitlán": [
        7881,
        7882
    ],
    "atlas": [
        7884,
        7885,
        7886
    ],
    "andres": [
        7890
    ],
    "ambonwari": [
        7892
    ],
    "aticum": [
        7893
    ],
    "atikum": [
        7893
    ],
    "amung": [
        7927
    ],
    "amung kal": [
        7927
    ],
    "amungme": [
        7927
    ],
    "amuy": [
        7927
    ],
    "afungwa": [
        7944
    ],
    "afra": [
        7948
    ],
    "awo-sumakuyu": [
        7952
    ],
    "awa je’ẽha": [
        7993
    ],
    "auramot": [
        8004
    ],
    "amba (solomon islands)": [
        8025
    ],
    "awa blang": [
        8032
    ],
    "a’erwa": [
        8032
    ],
    "adiwasi bhil": [
        8059,
        8060
    ],
    "annamese": [
        8078,
        8079,
        8080
    ],
    "antilles": [
        8081
    ],
    "afiki": [
        8095
    ],
    "ayautla": [
        8126
    ],
    "ayautla mazatec": [
        8126
    ],
    "alavana": [
        8128
    ],
    "alavano": [
        8128
    ],
    "awa (china)": [
        8146
    ],
    "awa wa": [
        8146
    ],
    "aruma": [
        8163
    ],
    "aura": [
        8169
    ],
    "alukuyana": [
        8173
    ],
    "ayana": [
        8173
    ],
    "alagwa": [
        8181
    ],
    "alaagwa’isa": [
        8181
    ],
    "alagwaisa": [
        8181
    ],
    "alagwase": [
        8181
    ],
    "albura": [
        8187
    ],
    "alpira": [
        8187
    ],
    "alpiri": [
        8187
    ],
    "amam": [
        8211
    ],
    "ambel": [
        8221
    ],
    "amber": [
        8221
    ],
    "amberi": [
        8221
    ],
    "alkan": [
        8236
    ],
    "adi andhra": [
        8247
    ],
    "ambule": [
        8275
    ],
    "agwamin": [
        8278
    ],
    "aropen": [
        8333
    ],
    "ajmeri": [
        8340
    ],
    "arwur": [
        8341
    ],
    "awarai": [
        8341
    ],
    "awarra": [
        8341
    ],
    "adilabad": [
        8343,
        8344,
        8345,
        8346
    ],
    "adilabad gondi": [
        8343,
        8344,
        8345,
        8346
    ],
    "aua-viwulu": [
        8372
    ],
    "ajurú": [
        8386
    ],
    "ayurú": [
        8386
    ],
    "andalusian arabic": [
        8389
    ],
    "andalusian": [
        8389
    ],
    "adai": [
        8392
    ],
    "aequian": [
        8393
    ],
    "aghwan": [
        8394
    ],
    "ararandewára": [
        8396
    ],
    "ararandeuras": [
        8396
    ],
    "ararandeuára": [
        8396
    ],
    "apalachee": [
        8403
    ],
    "aquitanian": [
        8404
    ],
    "a’uwẽ": [
        8409
    ],
    "akuên": [
        8409
    ],
    "akwen": [
        8409,
        8456
    ],
    "awen": [
        8409
    ],
    "a’uwe uptabi": [
        8409
    ],
    "a’uwe": [
        8409
    ],
    "a’we": [
        8409
    ],
    "akwun": [
        8418
    ],
    "abathwa": [
        8452
    ],
    "amabusmana": [
        8452
    ],
    "amankgqwigqwi": [
        8452
    ],
    "acuen": [
        8456
    ],
    "akwẽ": [
        8456
    ],
    "akwẽ-xerente": [
        8456
    ],
    "aré": [
        8458
    ],
    "ahia": [
        8459
    ],
    "ahiave": [
        8459
    ],
    "alauikeno": [
        8463
    ],
    "apau": [
        8502
    ],
    "alanic": [
        8524
    ],
    "ancient macedonian": [
        8540
    ],
    "antankarana": [
        8551
    ],
    "antakarana": [
        8551
    ],
    "antakarana malagasy": [
        8551
    ],
    "antankarana malagasy": [
        8551
    ],
    "antekarana": [
        8551
    ],
    "antekarana malagasy": [
        8551
    ],
    "ancient north arabian": [
        8556
    ],
    "angoni": [
        8561
    ],
    "anglo-norman": [
        8565
    ],
    "aweikoma": [
        8579
    ],
    "aweikoma-kaingang": [
        8579
    ],
    "armazic": [
        8621
    ],
    "arin": [
        8622
    ],
    "aranama-tamique": [
        8624
    ],
    "ammu": [
        8625
    ],
    "amu": [
        8625
    ],
    "asanga": [
        8635
    ],
    "assan": [
        8641
    ],
    "amutoura": [
        8644
    ],
    "alcozauca": [
        8645
    ],
    "alcozauca mixtec": [
        8645
    ],
    "alocozauca": [
        8645
    ],
    "alu kurumba": [
        8669
    ],
    "alu kurumba nonstandard kannada": [
        8669
    ],
    "aobidai of ongkarango": [
        8673
    ],
    "aobidai": [
        8673
    ],
    "arramouro": [
        8713
    ],
    "ancient zapotec": [
        8716
    ],
    "abendago": [
        8719
    ],
    "achawa": [
        8733,
        8734
    ],
    "adsawa": [
        8733,
        8734
    ],
    "adsoa": [
        8733,
        8734
    ],
    "ayao": [
        8733,
        8734
    ],
    "ayawa": [
        8733,
        8734
    ],
    "agwagwune": [
        8744
    ],
    "agwaguna": [
        8744
    ],
    "akurakura": [
        8744
    ],
    "atsang-bangwa": [
        8747
    ],
    "akapa": [
        8753
    ],
    "ayikiben": [
        8754
    ],
    "adiya": [
        8768,
        8769
    ],
    "adiyan": [
        8768,
        8769
    ],
    "appa": [
        8775
    ],
    "action": [
        8787
    ],
    "arabic, judeo-iraqi": [
        8791
    ],
    "azhe": [
        8813,
        8796
    ],
    "awyu, north": [
        8807
    ],
    "axi": [
        8812
    ],
    "ahi": [
        8812
    ],
    "axi yi": [
        8812
    ],
    "axibo": [
        8812
    ],
    "axipo": [
        8812
    ],
    "alapha": [
        8819
    ],
    "aisana": [
        8828
    ],
    "angguruk": [
        8831
    ],
    "angguruk yali": [
        8831
    ],
    "aluo naluo": [
        8835
    ],
    "aluo": [
        8858,
        8835
    ],
    "aribwaung": [
        8837
    ],
    "aribwaungg": [
        8837
    ],
    "af-maay": [
        8849
    ],
    "af-maay tiri": [
        8849
    ],
    "af-may": [
        8849
    ],
    "af-maymay": [
        8849
    ],
    "aiku": [
        8851
    ],
    "asaheipho": [
        8884
    ],
    "asahopho": [
        8884
    ],
    "ani": [
        8888
    ],
    "ani phowa": [
        8888
    ],
    "anipho": [
        8888
    ],
    "alo": [
        8889
    ],
    "alo phola": [
        8889
    ],
    "amazônica": [
        8896
    ],
    "arabic, judeo-tripolitanian": [
        8922
    ],
    "arabatura": [
        8957
    ],
    "arkabatura": [
        8957
    ],
    "ayizi": [
        8963
    ],
    "atepec": [
        8969
    ],
    "ayoquesco": [
        8974
    ],
    "ayoquesco zapotec": [
        8974
    ],
    "aloápam": [
        8985
    ],
    "aloápam zapotec": [
        8985
    ],
    "albarradas": [
        8987,
        9164
    ],
    "albarradas zapotec": [
        8987
    ],
    "altas": [
        9003
    ],
    "amazighe standard marocain": [
        9014
    ],
    "amazighe": [
        9014
    ],
    "abazinza": [
        9056
    ],
    "asande": [
        9108,
        9109
    ],
    "azande": [
        9108,
        9109
    ],
    "asunción": [
        9116,
        9130
    ],
    "asunción mixtepec zapotec": [
        9116
    ],
    "ayapanec": [
        9117
    ],
    "amatlán": [
        9134
    ],
    "amatlán zapotec": [
        9134
    ],
    "agustín": [
        9163
    ],
    "ashiwi": [
        9177
    ],
    "applicable": [
        9180
    ],
    "anx": [
        9184,
        9188
    ],
    "anywhere": [
        9189
    ]
};
